import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import "../../../assests/sharpNewStyle/css/bootstrap.min4.css";
import "../../../assests/sharpNewStyle/css/5.bb8e33da.chunk.css";
import SimpleReactValidator from "simple-react-validator";
import CUSTOMER_LOGO from "./staticHeader";
import Step1 from "./Step1.jsx";
import Step2_2021 from "./Step2.jsx";
import Step2Category1 from "./step2/Step2Category1.jsx";
import Step2Category2 from "./step2/Step2Category2.jsx";
import Step2Category3 from "./step2/Step2Category3.jsx";
import Step3 from "./Step3.jsx";
import Step4 from "./Step4.jsx";
import Soa from "../../AllSteps/Soa";
import Step4Agent from "../../AllSteps/Setp4Agent";
import Captcha from "../../Captcha/Captcha";
import StepsFooter from "./stepsFooter";
import { INITIAL_STATE } from "../../initialState";
import { connect } from "react-redux";
import LinearProgress from "@material-ui/core/LinearProgress";
import { withStyles } from "@material-ui/core/styles";
import * as DateUtil from "../../../Utils/DatePicker";
import { handleDateChange } from "../../../Utils/DateFormatter";
import { handleDateChangeNew } from "../../../Utils/DateFormatter1";

import {
  resetStore,
  saveLogout,
  submitForm,
  getClinicalName,
  removeplan,
  captchaValidation,
  setPageName,
  setStateParams,
  checkEligibility,
  uploadFile,
  deleteFile,
  yearSelection,
  setLoginStateParams,
  guestLogin,
  getZipCodes,
  getPlansEmail,
  setTokenTORedux,
  setDeepLink,
  getPlans,
  setEnrollRedirect,
  planSelectionContinue,
  setPendingApplFlag,
  downloadFormsPdf,
} from "../../../Redux/Actions/webAppActions";

import history from "../../../Utils/History";
import { Text, setLanguage } from "react-internationalization";
import moment from "moment";
import isEmpty from "lodash/isEmpty";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import SaveProgress from "../PlanListing/SaveProgress";
import RetireeText from "./RetireeText";
import { LANG } from "../../translations/dynamic";
import { saveAs } from "file-saver";

const styles = (props) => ({
  progressComplete: {
    backgroundColor: "#00695C",
  },
  root: {
    height: "20px",
  },
  progressIncomplete: {
    backgroundColor: "#b8880c",
  },
});
let test = false;
let lang = "en";
const typeOfFilesToUpload = [
  {
    label: "---select---",
    value: "",
    typeCode: "",
  },
  {
    label: "ID INFORMATION",
    value: "idInf",
    typeCode: "IDIN",
  },
  {
    label: "MEDICARE CARD",
    value: "medCard",
    typeCode: "MCR",
  },
  {
    label: "OTHERS",
    value: "misc",
    typeCode: "OTHR",
  },
];
const uploadFiles = [
  {
    label: "SOA",
    value: "",
  },
  {
    label: "ID INFORMATION",
    value: "",
  },
  {
    label: "MEDICARE CARD",
    value: "",
  },
  {
    label: "OTHERS",
    value: "",
  },
];
class PreEnrollForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showpopUp: false,
      clickedSaveNextIds: [],
      stepVal: this.props.agentLogin ? "step0" : "step1",
      data: { ...INITIAL_STATE },
      // data:
      //  this.props.preEnrollInfo.length === 0
      //     ? { ...INITIAL_STATE }
      //     : this.props.preEnrollInfo,
      disableCheck: false,
      physicians: this.props.physicians,
      authorizedrelations: this.props.authorizedrelations,
      selectedPlan: "",
      checkName: "",
      capthaVerified: this.props.captcha,
      hrx: "",
      snackBarOpen: false,
      alertMsg: "",
      severity: "",
      vertical: "top",
      horizontal: "center",
      attestationList: [],
      questionDate: [],
      isSoaFilled: false,
      SOA: {},
      fileType: "",
      viewurl: "",
      typeOfFilesToUpload: [
        {
          label:
            "---" +
            (props.lang === "es" ? LANG.COMMON_TEXT.select : "select") +
            "---",
          value: "",
          typeCode: "",
        },
        {
          label:
            props.lang === "es"
              ? LANG.COMMON_TEXT.INFORMATION
              : "ID INFORMATION",
          value: "idInf",
          typeCode: "IDIN",
        },
        {
          label:
            props.lang === "es"
              ? LANG.COMMON_TEXT.MEDICARECARD
              : "MEDICARE CARD",
          value: "medCard",
          typeCode: "MCR",
        },
        {
          label: props.lang === "es" ? LANG.COMMON_TEXT.OTHERS : "OTHERS",
          value: "misc",
          typeCode: "OTHR",
        },
      ],
      selectedFiles: [],
      urlList: [],
      isMounted: false,
      proposedvalid: true,
    };
    this.validator = new SimpleReactValidator();
    //this.AuthAddressFilled=true;
    this.mailingAddressFilled = true;
    this.dateArray = [];
    this.uploadFiles =
      Object.keys(this.props.preEnrollInfo).length === 0
        ? uploadFiles
        : [
            {
              label: "SOA",
              value: this.props.preEnrollInfo.soa,
            },
            {
              label: "ID INFORMATION",
              value: this.props.preEnrollInfo.idInf,
            },
            {
              label: "MEDICARE CARD",
              value: this.props.preEnrollInfo.medCard,
            },
            {
              label: "OTHERS",
              value: this.props.preEnrollInfo.misc,
            },
          ];
  }

  unload = () => {
    console.log("page unloaded");
  };

  async didMount() {
    if (!this.props.pendingApplFlag) {
      this.props.setStateParams("selectedIndex", null);
      this.setState({
        data: { ...this.state.data, ethnicityRace: [] },
      });
      this.props.setStateParams("permanentAddrStreet", null);
      this.props.setStateParams("permanentCity", null);
      this.props.setStateParams("permanentZip", null);
      this.props.setStateParams("physiciansData", []);
    }
    this.props.setPageName("enrollOnline");
    window.scroll(0, 0);
    if (!isEmpty(this.props.preEnrollInfo)) {
      let SelectedplanType =
        this?.props?.cardDetails &&
        this?.props?.cardDetails.filter(
          (selectedplan) =>
            selectedplan?.productId === this?.props?.preEnrollInfo?.productId
        )[0]?.planType;
      this.props.setStateParams("planType", SelectedplanType);
      let preUploadedFiles = this.props.preEnrollInfo?.attachmentList;
      let attestationDates = this.props.preEnrollInfo?.attestationList?.filter(
        (x) => x.answer !== "yes"
      );
      console.log("preUploadedFiles", preUploadedFiles);
      await this.setState({
        data: this.props.preEnrollInfo,
        selectedFiles: preUploadedFiles ? preUploadedFiles : [],
        urlList: preUploadedFiles ? preUploadedFiles : [],
        attestationList: this.props.preEnrollInfo?.attestationList,
        questionDate: attestationDates ? attestationDates : [],
      });

      await this.setState({
        data: {
          ...this.state.data,
          Socialnumber: this.props?.preEnrollInfo?.ssn,
        },
      });
      let preUploadedFilesName = [];
      for (let i = 0; i < preUploadedFiles.length; i++) {
        preUploadedFilesName.push(preUploadedFiles[i]?.attachmentName);
      }
      this.props.setStateParams(
        "uploadedFilesInPreEnroll",
        preUploadedFilesName
      );
      // console.log("cls=",preUploadedFilesName)
    }

    window.onbeforeunload = function () {
      return "";
    }.bind(this);

    if (this.props.year === "" || this.props.selectedPlan === "") {
      history.push("/e-Enroll/userLogin");
    }
    if (this.props.productCategory === "INDIVIDUAL") {
      await this.setState((prevState) => ({
        data: {
          ...prevState.data,
          emailAlert: "N",
        },
      }));
    }
    let data = this.state.data;
    if (data) {
      if (
        data.c1 !== "" ||
        data.c2 !== "" ||
        data.c3 !== "" ||
        data.c4 !== "" ||
        data.c5 !== "" ||
        data.c6 !== "" ||
        data.c7 !== "" ||
        data.c8 !== "" ||
        data.c9 !== "" ||
        data.c10 !== "" ||
        data.c11 !== "" ||
        data.c12 !== "" ||
        data.c13 !== "" ||
        data.c14 !== "" ||
        data.c15 !== "" ||
        data.c16 !== "" ||
        data.c22 !== "" ||
        data.aep !== "" ||
        data.sep !== "" ||
        data.c21 !== "" ||
        data.c20 !== ""
      ) {
        await this.setState({ disableCheck: true });
      }
    }

    //addded loaded state......
    let zip =
      this.props.deeplink === true ? this.props.dpzipCode : this.props.zip;
    await this.setState((prevState) => ({
      data: {
        ...prevState.data,
        permanentAddrStreet: this.state.data.permanentAddress.streetAddress,
        permanentCity: this.state.data.permanentAddress.city
          ? this.state.data.permanentAddress.city
          : this.props.cityName,
        permanentZip: this.state.data.permanentAddress.zipCode
          ? this.state.data.permanentAddress.zipCode
          : zip,
        mailingAddr: this.state.data.mailingAddress.streetAddress,
        mailingState: this.state.data.mailingAddress.state,
        mailingCity: this.state.data.mailingAddress.city,
        mailingzip: this.state.data.mailingAddress.zipCode,
        mailingAddressRequired:
          this.state.data.mailingAddress.streetAddress &&
          this.state.data.mailingAddress.city &&
          this.state.data.mailingAddress.zipCode
            ? "YES"
            : "",
        addressOfRep: this.state.data.authRepAddress?.streetAddress,
        medicareNumber: this.FormatMedicareNumber(
          this.state.data.medicareNumber
        ),
      },
      selectedPlan: this.props.selectedPlan,
    }));

    if (this.props.pendingApplFlag === true) {
      this.PhoneNumberFormatter();
      await this.setState((prevState) => ({
        data: {
          ...prevState.data,
          accessibleFormatVal:
            this.state.data.accessibleFormatVal !== "OTHER" &&
            this.state.data.accessibleFormatVal !== "B" &&
            this.state.data.accessibleFormatVal !== "L" &&
            this.state.data.accessibleFormatVal !== ""
              ? "OTHER"
              : this.state.data.accessibleFormatVal,
          accessibleFormatOth:
            this.state.data.accessibleFormatVal !== "OTHER" &&
            this.state.data.accessibleFormatVal !== "B" &&
            this.state.data.accessibleFormatVal !== "L" &&
            this.state.data.accessibleFormatVal !== ""
              ? this.state.data.accessibleFormatVal
              : "",
        },
      }));
    }
    lang = this.props.lang;
  }

  async componentDidMount() {
    if (
      this.props.preEnrollInfo?.appStatus === "READY" ||
      this.props.preEnrollInfo?.appStatus === "SUBMITTED"
    ) {
      this.setState({
        snackBarOpen: true,
        alertMsg:
          this.props.lang === "es"
            ? "La solicitud ya se envió. Cree una nueva solicitud"
            : "Application is already submitted.Please create a new application",
        severity: "error",
      });
    }
    if (this.props?.userId != "Guest") {
      await this.setState({
        data: {
          ...this.state.data,
          emailAddress: this?.props?.userId??window.sessionStorage.getItem("userId"),
        },
      });
    }
    this.didMount();
    this.props.setStateParams("clickedSaveNextIds", []);

    if (
      window.sessionStorage.getItem("Confirmation") &&
      !window.sessionStorage.getItem("isMounted")
    ) {
      window.sessionStorage.setItem("isMounted", true);
      // Refresh the page
      window.location.reload();
    }

    if (this.props.agentLogin === true) {
      if (
        this.props.soa?.MA1 === "YES" ||
        this.props?.soa?.productIds?.includes("MA1")
      ) {
        await this.setState({
          productIds: {
            ...this.state.productIds,
            MA1: "YES",
          },
        });
      }
      if (
        this.props.soa?.DSNP === "YES" ||
        this.props?.soa?.productIds?.includes("DSNP")
      ) {
        await this.setState({
          productIds: {
            ...this.state.productIds,
            DSNP: "YES",
          },
        });
      }
      if (
        this.props.soa?.E005 === "YES" ||
        this.props?.soa?.productIds?.includes("E005")
      ) {
        await this.setState({
          productIds: {
            ...this.state.productIds,
            E005: "YES",
          },
        });
      }
      if (
        this.props.soa?.E006 === "YES" ||
        this.props?.soa?.productIds?.includes("E006")
      ) {
        await this.setState({
          productIds: {
            ...this.state.productIds,
            E006: "YES",
          },
        });
      }
      if (
        this.props.soa?.PDP1 === "YES" ||
        this.props?.soa?.productIds?.includes("PDP1")
      ) {
        await this.setState({
          productIds: {
            ...this.state.productIds,
            PDP1: "YES",
          },
        });
      }
      this.props.setStateParams("productIds", this.state.productIds);
      if (
        (this.props?.soa?.MA1 === "YES" ||
          this.props?.soa?.productIds?.includes("MA1") ||
          this.props?.soa?.productIds?.includes("DSNP") ||
          this.props?.soa?.productIds?.includes("E005") ||
          this.props?.soa?.productIds?.includes("E006") ||
          this.props?.soa?.productIds?.includes("PDP1") ||
          this.props?.soa?.DSNP === "YES" ||
          this.props?.soa?.E005 === "YES" ||
          this.props?.soa?.E006 === "YES" ||
          this.props?.soa?.PDP1 === "YES") &&
        this.props?.soa?.agentName != "" &&
        this.props?.soa?.agentPhone != "" &&
        this.props?.soa?.agentSignutre != "" &&
        this.props?.soa?.beneficiaryAddress != "" &&
        this.props?.soa?.beneficiaryName != "" &&
        this.props?.soa?.beneficiaryPhone != "" &&
        this.props?.soa?.dateApntmntCmpltd != "" &&
        this.props?.soa?.initialMethodOfContact != "" &&
        this.props?.soa?.repDate != "" &&
        this.props?.soa?.repName != "" &&
        this.props?.soa?.repRelationShip != "" &&
        this.props?.soa?.repSignature != ""
      ) {
        await this.setState({
          isSoaFilled: true,
        });
      } else {
        await this.setState({
          isSoaFilled: false,
        });
      }
    }
  }

  FormatMedicareNumber = (value) => {
    let c = 0;

    if (value.includes("-") || value.length > 11) {
      value = value.replace(/-/g, "");
      value = value.slice(0, 11);
    }
    if (value.length === 11 && value.indexOf("-") === -1) {
      value =
        value.slice(0, 4) + "-" + value.slice(4, 7) + "-" + value.slice(7);
    }
    let check = value.replace(/-/g, "");
    if (check.length < 11) {
      value = check;
    }
    for (let i = 0; i < value.length; i++) {
      if (value[i] === "-") {
        c = c + 1;
      }
    }
    if (check.length === 11 && c < 2) {
      value = check;
      value =
        value.slice(0, 4) + "-" + value.slice(4, 7) + "-" + value.slice(7);
    }
    return value.toUpperCase();
    //  }
  };

  PhoneNumberFormatter = () => {
    let primarynumber = this.props.preEnrollInfo.primaryPhoneNum;
    if (this.props.preEnrollInfo.primaryPhoneNum?.length === 10) {
      primarynumber =
        // "(" +
        this.props.preEnrollInfo.primaryPhoneNum?.slice(0, 3) +
        // ") " +
        this.props.preEnrollInfo.primaryPhoneNum?.slice(3, 6) +
        // "-" +
        this.props.preEnrollInfo.primaryPhoneNum?.slice(6, 10);
    }
    let cellnumber = this.props.preEnrollInfo.cellPhoneNum;
    if (this.props.preEnrollInfo.cellPhoneNum?.length === 10) {
      cellnumber =
        // "(" +
        this.props.preEnrollInfo.cellPhoneNum?.slice(0, 3) +
        // ") " +
        this.props.preEnrollInfo.cellPhoneNum?.slice(3, 6) +
        // "-" +
        this.props.preEnrollInfo.cellPhoneNum?.slice(6, 10);
    }
    let authrepnumber = this.props.preEnrollInfo.phoneNumberOfRep;
    if (this.props.preEnrollInfo.phoneNumberOfRep?.length === 10) {
      authrepnumber =
        // "(" +
        this.props.preEnrollInfo.phoneNumberOfRep?.slice(0, 3) +
        // ") " +
        this.props.preEnrollInfo.phoneNumberOfRep?.slice(3, 6) +
        // "-" +
        this.props.preEnrollInfo.phoneNumberOfRep?.slice(6, 10);
    }
    let otherPhone = this.props.preEnrollInfo.otherPhone;
    if (this.props.preEnrollInfo.otherPhone?.length === 10) {
      otherPhone =
        // "(" +
        this.props.preEnrollInfo.otherPhone?.slice(0, 3) +
        // ") " +
        this.props.preEnrollInfo.otherPhone?.slice(3, 6) +
        // "-" +
        this.props.preEnrollInfo.otherPhone?.slice(6, 10);
    }
    this.setState({
      // isSoaFilled: true,
      data: {
        ...this.state.data,
        primaryPhoneNum: primarynumber,
        cellPhoneNum: cellnumber,
        phoneNumberOfRep: authrepnumber,
        otherPhone: otherPhone,
      },
    });
  };

  async componentWillMount() {
    let queryString = window.location.search;
    let customerId = "";
    let zipCd = "";
    let countyCd = "";
    let stateCd = "";
    let countyName = "";
    let productID = "";
    let username = "";
    let productCategory = "";
    let selectedPlanName = "";
    let appId = "";
    let year = "";
    // let planCardData = "";
    // SONAR let index = 0;
    if (queryString.includes("deepLink=true")) {
      let queryStringArray = queryString.split("&");
      if (queryStringArray[1].includes("customerId")) {
        customerId = window.atob(queryStringArray[1].split("=")[1]);
      }
      if (queryStringArray[2].includes("zipCd")) {
        zipCd = window.atob(queryStringArray[2].split("=")[1]);
      }
      if (queryStringArray[3].includes("countyCd")) {
        countyCd = window.atob(queryStringArray[3].split("=")[1]);
      }

      if (queryStringArray[4].includes("stateCd")) {
        stateCd = window.atob(queryStringArray[4].split("=")[1]);
      }
      if (queryStringArray[5].includes("countyName")) {
        countyName = window.atob(queryStringArray[5].split("=")[1]);
      }

      if (queryStringArray[6].includes("productId")) {
        productID = window.atob(queryStringArray[6].split("=")[1]);
      }
      if (queryStringArray[7].includes("email")) {
        username = window.atob(queryStringArray[7].split("=")[1]);
      }
      if (queryStringArray[10].includes("productCategory")) {
        productCategory = window.atob(queryStringArray[10].split("=")[1]);
      }
      if (queryStringArray[11].includes("selectedPlanName")) {
        selectedPlanName = window.atob(queryStringArray[11].split("=")[1]);
      }
      if (queryStringArray[12].includes("appId")) {
        appId = window.atob(queryStringArray[12].split("=")[1]);
      }
      if (queryStringArray[13].includes("year")) {
        year = window.atob(queryStringArray[13].split("=")[1]);
      }
      if (queryStringArray[14].includes("lang")) {
        lang = window.atob(queryStringArray[14].split("=")[1]);
      }
      this.props.setStateParams("language", lang);
      this.props.yearSelection(year);

      await this.props.setDeepLink({
        deeplink: true,
        countyName: countyName,
        zipcode: zipCd,
        productId: productID,
        stateCd: stateCd,
        email: username,
      });

      let guestpayload = {
        customerId: customerId,
        username: username,
      };
      const guestLoginDetails = await this.props.guestLogin(guestpayload);
      await this.props.setTokenTORedux(guestLoginDetails.data.token);

      this.props.setLoginStateParams("token", guestLoginDetails.data.token);
      this.props.setStateParams("zipCodes", []);
      this.props.setLoginStateParams("selectedPlanName", selectedPlanName);
      this.props.setLoginStateParams("deeplinkflag", true);
      this.props.setLoginStateParams("productCategory", productCategory);
      //Load application..
      const response = await this.props.setEnrollRedirect(
        appId,
        username,
        customerId
      );
      if (response?.status != "OK") {
        // let msg=response?.message?response?.message:response?.data?.message
        this.props.setStateParams("storeshowpopUp", true);
        // this.setState({
        //       snackBarOpen: true,
        //       //alertMsg: msg,
        //       alertMsg:"System error.Please try later",
        //       severity: "error",
        //     });
        //     setTimeout(() => {
        //       history.push("/e-Enroll/userLogin");
        //     }, 2000);
        // return
      }
      window.sessionStorage.setItem("token", guestLoginDetails.data.token);
      await this.props.getZipCodes(response.data.permanentAddress?.zipCode);
      // const params = this.props.ZipCodes.filter(
      //   (zipcode1) =>
      //     zipcode1.countyName === response.data.permanentAddress?.county
      // );

      const cardDatas = await this.props.getPlans(
        zipCd,
        countyCd,
        customerId,
        stateCd,
        year
      );
      if (cardDatas?.status != "OK") {
        //let msg=cardDatas?.message?cardDatas?.message:cardDatas?.data?.message
        this.props.setStateParams("storeshowpopUp", true);
        // this.setState({
        //   snackBarOpen: true,
        //   alertMsg: msg,
        //   severity: "error",
        // });
        //     setTimeout(() => {
        //       history.push("/e-Enroll/userLogin");
        //     }, 2000);
        // return
      }
      let plnType = cardDatas.data.summaryList.filter(
        (x) => x.productId === response.data.productId
      );

      await this.props.setStateParams("planType", plnType[0]?.planType);
      await this.props.setStateParams(
        "zip",
        response.data.permanentAddress?.zipCode
      );
      await this.props.setStateParams(
        "stateId",
        response.data.permanentAddress?.state
      );
      await this.props.setStateParams(
        "CountyCd",
        response.data.permanentAddress?.countyCd
      );
      await this.props.setStateParams(
        "county",
        response.data.permanentAddress?.county
      );
      window.sessionStorage.setItem("zipcode", zipCd);
      window.sessionStorage.setItem("year", year);
      window.sessionStorage.setItem("guestLogin", true);
      window.sessionStorage.setItem(
        "countySelect",
        response.data.permanentAddress?.county
      );
      this.props.setLoginStateParams("selectedPlan", plnType[0]?.planId);
      const response1 = await this.props.planSelectionContinue(
        {
          planId: plnType[0]?.planId,
          premiumAmount: plnType[0]?.monthlyPremium,
          productId: plnType[0]?.productId,
          customerId: customerId,
        },
        customerId
      );

      if (response1.status === "OK") {
        await this.props.setPendingApplFlag(true);
        await this.props.setStateParams("appNum", appId);
        await this.props.yearSelection({ planYear: year });
        this.didMount();
        history.push("/e-Enroll/enrollOnline");
      }
    } else {
      lang = this.props.lang;
    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onUnload);
    window.sessionStorage.removeItem("isMounted", true);
    window.sessionStorage.removeItem("Confirmation");
  }

  handleSteps = async (event) => {
    let value = event.target ? event.target.id : event.id;
    if (value === "step0" && this.state.stepVal !== "step0") {
      await this.setState((prevState) => ({
        ...prevState,
        // snackBarOpen: true,
        // alertMsg: "SOA is already filled",
        // severity: "error",
        // stepVal: this.state.stepVal,
        stepVal: value,
      }));
    } else if (this.state.stepVal === "step0" && value !== "step0") {
      if (this.state.isSoaFilled === false) {
        await this.setState((prevState) => ({
          ...prevState,
          snackBarOpen: true,
          alertMsg:
            this.props.lang === "es"
              ? "Por favor, rellene todos los campos obligatorios y haga clic en guardar y siguiente."
              : "Please fill all the mandatory fields and click on save and next.",
          severity: "error",
          stepVal: "step0",
        }));
      } else {
        await this.setState((prevState) => ({
          ...prevState,
          // snackBarOpen: true,
          // alertMsg:
          //   "Please fill all the mandatory fields and click on save and next.",
          // severity: "error",
          stepVal: value,
        }));
      }
    } else {
      if (value) {
        await this.setState({ stepVal: value });
      }
    }
    // if(value==="step2"){
    //   await props.captchaValidation(false)
    // }
  };
  handleDates = async (fieldId) => {
    DateUtil.getDatePicker("#" + fieldId).datepicker("show");
    DateUtil.getDatePicker("#" + fieldId).on("change", (e) => {
      this.setDates(fieldId, e.target.value);
    });
    let flag = this.props.agentLogin ? true : false;
    await this.props.captchaValidation(flag);
  };

  setDates = async (fieldId, value) => {
    await this.setState({ data: { ...this.state.data, [fieldId]: value } });
  };
  handleDateNew = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    DateUtil.getStartDatePickerofMonth("#" + name).datepicker("hide");
    value = handleDateChangeNew(value);
    if (value.length === 10) {
      if (!moment(value, "MM/DD/YYYY", true).isValid()) {
        this.setState({
          snackBarOpen: true,
          alertMsg: "Please enter a valid date ",
          severity: "error",
        });
      }
      if (moment(value, "MM/DD/YYYY", true).isValid()) {
        if (name === "partAEffDate") {
          let splittedDate = value.split("/");
          if (splittedDate.length === 3) {
            if (splittedDate[2] !== "" && splittedDate[2].length === 4) {
              if (Number(splittedDate[1]) > 1) {
                this.setState({
                  snackBarOpen: true,
                  alertMsg: "Please enter first date of a month.",
                  severity: "error",
                  partAvalid: false,
                  // data: { ...this.state.data, [name]: "" },
                });
              } else {
                this.setState({
                  partAvalid: true,
                });
              }
            }
          }
        }
        if (name === "partBEffDate") {
          let splittedDate = value.split("/");
          if (splittedDate.length === 3) {
            if (splittedDate[2] !== "" && splittedDate[2].length === 4) {
              if (Number(splittedDate[1]) > 1) {
                this.setState({
                  snackBarOpen: true,
                  alertMsg: "Please enter first date of a month.",
                  severity: "error",
                  partBvalid: false,
                  // data: { ...this.state.data, [name]: "" },
                });
              } else {
                this.setState({
                  partBvalid: true,
                });
              }
            }
          }
        }
        if (name === "proposedEffDate") {
          let splittedDate = value.split("/");
          // let currentYear = new Date().getFullYear();
          // let currentMonth = new Date().getMonth() + 1;
          if (splittedDate.length === 3) {
            if (splittedDate[2] !== "" && splittedDate[2].length === 4) {
              // this.CalcNext3months();
              // if (
              //   (splittedDate[1].toString() === "01" &&
              //     Number(splittedDate[0]).toString() ===
              //       nxtFirstMonth.toString() &&
              //     Number(splittedDate[2]).toString() ===
              //       nxtFirstMonthYear.toString()) ||
              //   (Number(splittedDate[0]).toString() ===
              //     nxtSecondMonth.toString() &&
              //     Number(splittedDate[2]).toString() ===
              //       nxtSecondMonthYear.toString()) ||
              //   (Number(splittedDate[0]).toString() ===
              //     nxtThirdMonth.toString() &&
              //     Number(splittedDate[2]).toString() ===
              //       nxtThirdMonthYear.toString())
              // ) {
              //   this.setState({
              //     proposedvalid: true,
              //   });
              // } else {
              //   this.setState({
              //     snackBarOpen: true,
              //     alertMsg:
              //       "Please enter first date of next 3 months of current year.",
              //     severity: "error",
              //     proposedvalid: false,
              //     // data: { ...this.state.data, [name]: "" },
              //   });
              // }
              var dt = new Date();
              var mon = dt.getMonth() + 1;
              var year = dt.getFullYear();
              var planYear = Number(this.props.year);
              // var planYear =  Number(splittedDate[2])
              let nxtFirstMonth = mon + 1,
                nxtSecondMonth = mon + 2,
                nxtThirdMonth = mon + 3;
              // let nxtFirstMonthYear=year,nxtSecondMonthYear=year,nxtThirdMonthYear=year
              if (planYear > year) {
                if (
                  splittedDate[1].toString() === "01" &&
                  Number(splittedDate[0]) === 1 &&
                  Number(splittedDate[2]) === year + 1
                ) {
                  this.setState({
                    proposedvalid: true,
                  });
                } else {
                  this.setState({
                    snackBarOpen: true,
                    alertMsg:
                      "Please enter first date of next 3 months of current year.",
                    severity: "error",
                    proposedvalid: false,
                  });
                }
              } else {
                if (nxtFirstMonth > 11) {
                  nxtFirstMonth = nxtFirstMonth - 12;
                  //  nxtFirstMonthYear=year+1
                }
                if (nxtSecondMonth > 11) {
                  nxtSecondMonth = nxtSecondMonth - 12;
                  // nxtSecondMonthYear=year+1
                }
                if (nxtThirdMonth > 11) {
                  nxtThirdMonth = nxtThirdMonth - 12;
                  // nxtThirdMonthYear=year+1
                }

                if (
                  splittedDate[1].toString() === "01" &&
                  Number(splittedDate[0]) > mon &&
                  ((Number(splittedDate[0]) === nxtFirstMonth &&
                    Number(splittedDate[2]) === year) ||
                    (Number(splittedDate[0]) === nxtSecondMonth &&
                      Number(splittedDate[2]) === year) ||
                    (Number(splittedDate[0]) === nxtThirdMonth &&
                      Number(splittedDate[2]) === year) ||
                    (Number(splittedDate[0]) === 12 &&
                      Number(splittedDate[2]) === year))
                ) {
                  this.setState({
                    proposedvalid: true,
                  });
                } else {
                  this.setState({
                    snackBarOpen: true,
                    alertMsg:
                      "Please enter first date of next 3 months of current year.",
                    severity: "error",
                    proposedvalid: false,
                  });
                }
              }
            }
          }
          // if (splittedDate.length === 3) {
          //   if (splittedDate[2] !== "" && splittedDate[2].length === 4) {
          //     if(this?.props?.year===currentYear?.toString()){
          //     if (
          //       Number(splittedDate[1]) > 1 ||
          //       splittedDate[2] != currentYear ||
          //       (splittedDate[0] != "" &&
          //         splittedDate[0].length === 2 &&
          //         (currentMonth + 3 < splittedDate[0] ||
          //           splittedDate[0] <= currentMonth))
          //     ) {
          //       this.setState({
          //         snackBarOpen: true,
          //         alertMsg:
          //           "Please enter first date of next 3 months of current year.",
          //         severity: "error",
          //         proposedvalid: false,
          //         // data: { ...this.state.data, [name]: "" },
          //       });
          //     } else {
          //       this.setState({
          //         proposedvalid: true,
          //       });
          //     }
          //   }
          //   else{
          //     //selected year is greater than current year
          //     if (
          //       splittedDate[1] != "01" ||
          //       (splittedDate[2] != this?.props?.year) ||
          //       splittedDate[0] === "" ||
          //           splittedDate[0]!="01"
          //     ) {
          //       this.setState({
          //         snackBarOpen: true,
          //         alertMsg:
          //           // "Please enter first date of January of the selected year.",
          //           `Invalid effective date for ${this?.props?.year} plan year`,
          //         severity: "error",
          //         proposedvalid: false,
          //         // data: { ...this.state.data, [name]: "" },
          //       });
          //     } else {
          //       this.setState({
          //         proposedvalid: true,
          //       });
          //     }
          //   }
          //   }
          // }
        }
      }
    }
    await this.setState({
      data: { ...this.state.data, [name]: value },
    });
    // DateUtil.getRequEfftDatePicker("#" + name,this?.props?.year).datepicker("show");
  };
  handleReqEffDates = (fieldId) => {
    DateUtil.getRequEfftDatePicker("#" + fieldId, this?.props?.year).datepicker(
      "show"
    );
    DateUtil.getRequEfftDatePicker("#" + fieldId, this?.props?.year).on(
      "change",
      (e) => {
        this.setDates(fieldId, e.target.value);
        DateUtil.getRequEfftDatePicker("#" + fieldId, this?.props?.year);
        //.datepicker("refresh");
      }
    );
  };
  handleCheckbox2 = async (event) => {
    let name = event.target.name;
    let value = event.target.checked;
    if (name === "mailingAddressRequired") {
      value = event.target.checked ? "YES" : "";
    }
    if (name === "prefLng") {
      value = event.target.checked ? event.target.value : "";
    }

    // if (name === "accessibleFormatVal") {
    //   value = event.target.checked ? "OTHER" : "";
    // }
    await this.setState({
      data: { ...this.state.data, [name]: value },
    });
    let flag = this.props.agentLogin ? true : false;
    await this.props.captchaValidation(flag);
  };
  handleCheckbox = async (event) => {
    let name = event.target.name;
    let value = event.target.checked;
    let save = "";

    if (name === "aep") {
      value = event.target.checked ? "AEP" : "";
      save = name;
    }
    if (name === "sep") {
      value = event.target.checked ? "5ST" : "";
      save = name;
    }
    if (name === "c20") {
      value = event.target.checked ? "OEP" : "";
      save = name;
    }

    if (name === "c21") {
      value = event.target.checked ? "OEPN" : "";
      save = name;
    }
    if (name === "c1") {
      value = event.target.checked ? "NEW" : "";
      save = name;
    }
    if (name === "c2") {
      value = event.target.checked ? "MOV" : "";
      save = name;

      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation2: "" } });
      }
    }
    if (name === "c3") {
      value = event.target.checked ? "INC" : "";
      save = name;
      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation3: "" } });
      }
    }
    if (name === "c4") {
      value = event.target.checked ? "RUS" : "";
      save = name;
      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation4: "" } });
      }
    }
    if (name === "c5") {
      value = event.target.checked ? "LAW" : "";
      save = name;
      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation5: "" } });
      }
    }
    if (name === "c6") {
      value = event.target.checked ? "MDE" : "";
      save = name;
    }
    if (name === "c8") {
      value = event.target.checked ? "NLS" : "";
      save = name;
      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation8: "" } });
      }
    }
    if (name === "c9") {
      value = event.target.checked ? "LTC" : "";
      save = name;
      if (value === "") {
        await this.setState({ data: { ...this.state.data, attestation9: "" } });
      }
    }
    if (name === "c10") {
      value = event.target.checked ? "PAC" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation10: "" },
        });
      }
    }
    if (name === "c11") {
      value = event.target.checked ? "LCC" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation11: "" },
        });
      }
    }
    if (name === "c12") {
      value = event.target.checked ? "LEC" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation12: "" },
        });
      }
    }
    if (name === "c13") {
      value = event.target.checked ? "PAP" : "";
      save = name;
    }
    if (name === "c14") {
      value = event.target.checked ? "EOC" : "";
      save = name;
    }
    if (name === "c15") {
      value = event.target.checked ? "SNP" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation15: "" },
        });
      }
    }
    if (name === "c22") {
      value = event.target.checked ? "MCD" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, recentlyChangeMedicaid: "" },
        });
      }
    }
    if (name === "c23") {
      value = event.target.checked ? "HLP" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation23: "" },
        });
      }
    }
    if (name === "c25") {
      value = event.target.checked ? "DST" : "";
      save = name;
    }
    if (name === "c7") {
      value = event.target.checked ? "HLP" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, attestation7: "" },
        });
      }
    }
    if (name === "c16") {
      value = event.target.checked ? "OTH" : "";
      save = name;
      if (value === "") {
        await this.setState({
          data: { ...this.state.data, c16Attestation: "", attestation16: "" },
        });
      }
    }

    await this.setState({
      data: { ...this.state.data, [name]: value },
      checkName: save,
    });

    if (value === "") {
      await this.setState({ disableCheck: false });
    } else {
      await this.setState({ disableCheck: true });
      test = true;
    }
    let flag = this.props.agentLogin ? true : false;
    await this.props.captchaValidation(flag);
  };
  getData = (stateObj) => {
    let attestqsns = stateObj.attestationList;
    let productinSoa = "";
    let getProductId = "";
    let getCounty = "";

    // if (this.props.deeplink && this.props.dpProductId) {
    //     getProductId = this.props.dpProductId;
    //     console.log("getProductId 1",getProductId)
    //   } else
    if (this.props.preEnrollInfo.productId) {
      getProductId = this.props.preEnrollInfo.productId;
    } else if (stateObj.data?.productId) {
      getProductId = stateObj.data?.productId;
    } else {
      getProductId = this.props.productId;
    }

    if (stateObj.data?.permanentCounty?.countyName) {
      getCounty = stateObj.data.permanentCounty.countyName?.slice(0, 3);
    } else if (this.props.county) {
      if (this.props.county?.countyName) {
        getCounty = this.props.county?.countyName;
      } else {
        getCounty = this.props.county;
      }
    } else {
      getCounty = stateObj.data.permanentCounty?.slice(0, 3);
    }

    for (const key in this.props.productIds) {
      if (this.props.productIds[key] == "YES") {
        productinSoa = productinSoa + key + ",";
      }
    }

    const clinicfilter =
      this.props.physiciansData.length > 1
        ? this.props.physiciansData.filter(
            (data1) =>
              // this.props.pendingApplFlag
              //   ? data1.label === data.pcpName
              data1.doctorName === this.props.pcpSelected.pcpName
          )[0] != undefined
          ? this.props.physiciansData.filter(
              (data1) =>
                // this.props.pendingApplFlag
                //   ? data1.label === data.pcpName
                data1.doctorName === this.props.pcpSelected.pcpName
            )[0].clinicName
          : ""
        : "";

    const { pendingApplFlag, year } = this.props;
    let planYear = stateObj.data.planYear ? stateObj.data.planYear : year;
    let efDate;
    // if (new Date().getFullYear() < planYear) {
    //   if (
    //     ((new Date().getMonth() + 1).toString().padStart(2, "0") === "10" &&
    //       new Date().getDate().toString().padStart(2, "0") > 14) ||
    //     (new Date().getMonth() + 1).toString().padStart(2, "0") === "11" ||
    //     ((new Date().getMonth() + 1).toString().padStart(2, "0") === "12" &&
    //       new Date().getDate().toString().padStart(2, "0") < 8)
    //   ) {
    //     efDate = "01/01/" + (new Date().getFullYear() + 1);
    //   } else {
    //     efDate =
    //       (new Date().getMonth() + 1).toString().padStart(2, "0") +
    //       "/01/" +
    //       ((new Date().getMonth() + 1).toString().padStart(2, "0") === "12"
    //         ? new Date().getFullYear() + 1
    //         : new Date().getFullYear());
    //   }
    // } else {
    //   efDate =
    //     (new Date().getMonth() + 2).toString().padStart(2, "0") +
    //     "/01/" +
    //     ((new Date().getMonth() + 1).toString().padStart(2, "0") === "12"
    //       ? new Date().getFullYear() + 1
    //       : new Date().getFullYear());
    // }
    let todayIs = new Date();
    let nextMonth = todayIs.getMonth() + 2;
    let mnth = nextMonth > 12 ? nextMonth - 12 : nextMonth;
    let finalYear = nextMonth > 12 ? Number.parseInt(planYear) + 1 : planYear;
    efDate =
      Number.parseInt(planYear) > todayIs.getFullYear()
        ? `01/01/${planYear}`
        : `${mnth < 10 ? 0 : ""}${mnth}/01/${finalYear}`;
    const data2 = {
      customerId: this.props?.customerId,
      planYear: stateObj.data.planYear ? stateObj.data.planYear : year,
      productCategory: this.props?.productCategory,
      appStatus: "",
      appNumber: pendingApplFlag
        ? // authenticatedData.pendingAppNum
          this.props?.appNum
        : this.props.guestbeneagentAppNum
        ? this.props.guestbeneagentAppNum
        : this.props.count
        ? this.props.count
        : null,
      //  (this.props.guestLogin
      //     ?(this.props.guestAppNum?this.props.guestAppNum:null)
      //     :!this.props.agentLoggedIn?(this.props.beneAppNum?this.props.beneAppNum:null):null),
      //planName: this.props.planName.slice(0, 3),
      planName: this.props.preEnrollInfo.planName
        ? this.props.preEnrollInfo.planName
        : pendingApplFlag
        ? stateObj.data.planName
        : this.props.planName,
      //this.props.selectedProductName,
      productId: getProductId,
      premimumAmount: this.props.premiumAmount ? this.props.premiumAmount : 0,
      prefix: stateObj.data.prefix,
      firstName: stateObj.data.firstName,
      lastName: stateObj.data.lastName,
      middleInitial: stateObj.data.middleInitial,
      birthDate: stateObj.data.birthDate,
      sex: stateObj.data?.sex ? stateObj.data?.sex : "",
      primaryPhoneNum:
        stateObj.data.primaryPhoneNum != null &&
        stateObj.data.primaryPhoneNum != undefined &&
        stateObj.data.primaryPhoneNum != ""
          ? stateObj.data.primaryPhoneNum.replace(/[^0-9]/g, "").slice(0, 10)
          : "",
      cellPhoneNum:
        stateObj.data.cellPhoneNum != null &&
        stateObj.data.cellPhoneNum != undefined &&
        stateObj.data.cellPhoneNum != ""
          ? stateObj.data.cellPhoneNum.replace(/[^0-9]/g, "").slice(0, 10)
          : "",
      otherPhone:
        stateObj.data?.otherPhone != null &&
        stateObj.data?.otherPhone != undefined &&
        stateObj.data?.otherPhone != ""
          ? stateObj.data?.otherPhone.replace(/[^0-9]/g, "").slice(0, 10)
          : "",
      //primaryPhoneNum:"67686",
      proposedEffDate:
        this?.props?.productCategory === "INDIVIDUAL"
          ? // && this?.props?.year
            efDate //"01/01/2024"
          : moment(
              stateObj.data?.proposedEffDate,
              "MM/DD/YYYY",
              true
            ).isValid() && stateObj?.proposedvalid === true
          ? stateObj.data?.proposedEffDate
          : "",
      ssn: stateObj.data?.Socialnumber,
      medicareNumber: stateObj?.data?.medicareNumber
        ? stateObj.data.medicareNumber?.replaceAll("-", "").slice(0, 11)
        : "",
      //medicareNumber:"23235",
      isDrugCoverage: stateObj.data.isDrugCoverage,
      nameOfCoverage: stateObj.data.nameOfCoverage,
      covMemberNumber: stateObj.data.covMemberNumber,
      covGroupNumber: stateObj.data.covGroupNumber,
      lastNameOfRep: stateObj.data?.lastNameOfRep,
      middleNameOfRep: stateObj.data?.middleNameOfRep,
      // address3:this.state.data?.address3,
      isAuthRepresentative: stateObj.data.isAuthRepresentative,
      nameOfRep: stateObj.data.nameOfRep,
      relationOfRep: stateObj.data.relationOfRep,
      phoneNumberOfRep: stateObj.data.phoneNumberOfRep
        ? stateObj.data.phoneNumberOfRep
            .replace("(", "")
            .replace(")", "")
            .replace("-", "")
            .replace(" ", "")
        : "",
      isLicensedSalesRep: stateObj.data.isLicensedSalesRep,
      salRepName: stateObj.data.salRepName,
      salRepLicenseNumber: stateObj.data.salRepLicenseNumber,
      accessibleFormatVal:
        stateObj.data.accessibleFormatVal.replace("_", "") === "OTHER"
          ? stateObj.data.accessibleFormatOth
          : stateObj.data.accessibleFormatVal.replace("_", ""),
      // language: stateObj.data?.language,
      // accessibleFormatOthersVal: this.state.data.accessibleFormatOthersVal,

      prefLng: stateObj.data?.prefLng ?? "",
      // accessibleFormatOthersVal: this.state.data.accessibleFormatOthersVal, need to be change
      pcpName: this.props.pcpSelected.pcpName
        ? this.props.pcpSelected.pcpName
        : this.props.preEnrollInfo.pcpName
        ? this.props.preEnrollInfo.pcpName
        : "",
      pcpAddress: this.props.pcpSelected.pcpAddress
        ? this.props.pcpSelected.pcpAddress
        : this.props?.preEnrollInfo?.pcpAddress
        ? this.props.preEnrollInfo.pcpAddress
        : "",
      clinicName: clinicfilter
        ? clinicfilter
        : this.props.preEnrollInfo.clinicName
        ? this.props.preEnrollInfo.clinicName
        : "",
      emailAddress: stateObj.data.emailAddress,
      emailOptionIndicator: stateObj.data.emailOptionIndicator,
      isCurrentPatient: stateObj.data.isCurrentPatient,
      isSpouseWork: stateObj.data.isSpouseWork,
      doYouWork: stateObj.data.doYouWork,
      attachmentList: [],
      authRepAddress: {
        streetAddress: stateObj.data?.addressOfRep
          ? stateObj.data.addressOfRep
          : "",
        address2: stateObj.data?.addressOfRep2
          ? stateObj.data?.addressOfRep2
          : "",
        address3: stateObj.data?.address3 ? stateObj.data?.address3 : "",
        city: stateObj.data?.authRepCity ? stateObj.data?.authRepCity : "",
        state: stateObj.data?.authRepState ? stateObj.data?.authRepState : "",
        zipCode: stateObj.data?.authRepZip ? stateObj.data?.authRepZip : "",
      },
      permanentAddress: {
        streetAddress: stateObj.data.permanentAddrStreet,
        address2: stateObj?.data?.permanentAddr2,
        city: stateObj.data.permanentCity?.slice(0, 20),
        county: getCounty,
        state: this.props.stateId ? this.props.stateId : "",
        zipCode: stateObj.data.permanentZip,
        countyCd: this.props.CountyCd ? this.props.CountyCd : "",
      },
      mailingAddress: {
        streetAddress: stateObj.data.mailingAddr,
        address2: stateObj?.data.mailingAddr2,
        city: stateObj.data.mailingCity?.slice(0, 10),
        county: "",
        state: "CA",
        zipCode: stateObj.data.mailingzip,
      },
      attestationList: attestqsns ? attestqsns : [],
      soaDetails: this.props.agentId
        ? {
            salesChannelOth: this.props?.soa?.salesChannelOth,
            productIds: productinSoa ? productinSoa.replace(/,*$/, "") : "",
            repName: this.props.soa?.repName ? this.props.soa.repName : "",
            repRelationShip: this.props.soa?.repRelationShip
              ? this.props.soa?.repRelationShip?.slice(0, 20)
              : "",
            repSignature: this.props.soa?.repSignature
              ? this.props.soa?.repSignature
              : "",
            repDate: this.props.soa?.repDate ? this.props.soa?.repDate : "",
            agentId: this.props.agentId ? this.props.agentId : null,
            agentName: this.props.soa?.agentName
              ? this.props.soa?.agentName
              : "",
            agentPhone: this.props.soa?.agentPhone
              ? this.props.soa?.agentPhone
                  .replace("(", "")
                  .replace(")", "")
                  .replace("-", "")
                  .replace(" ", "")
              : "",
            agentSignutre: this.props.soa?.agentSignutre
              ? this.props.soa?.agentSignutre
              : "",
            dateApntmntCmpltd: this.props.soa?.dateApntmntCmpltd
              ? this.props.soa?.dateApntmntCmpltd
              : "",
            beneficiaryName: this.props.soa?.beneficiaryName
              ? this.props.soa?.beneficiaryName
              : "",
            beneficiaryPhone: this.props.soa?.beneficiaryPhone
              ? this.props.soa?.beneficiaryPhone
                  .replace("(", "")
                  .replace(")", "")
                  .replace("-", "")
                  .replace(" ", "")
              : "",
            beneficiaryAddress: this.props.soa?.beneficiaryAddress
              ? this.props.soa?.beneficiaryAddress
              : "",
            initialMethodOfContact: this.props.soa?.initialMethodOfContact
              ? this.props.soa?.initialMethodOfContact?.slice(0, 6)
              : "",
            medicaidId: this.props.soa?.medicaidId ?? "",
            beneficiaryInitial: this.props.soa?.beneficiaryInitial ?? "",
          }
        : null,
      todayDate:
        (new Date().getMonth() + 1).toString().padStart(2, "0") +
        "/" +
        new Date().getDate().toString().padStart(2, "0") +
        "/" +
        new Date().getFullYear(),
      name: stateObj.data.name,
      signature: stateObj.data.name,
      isSigned: stateObj.data.agentSign || stateObj.data.name ? "Y" : "N",
      officeCd: this.props.pcpSelected.pcpOfficeCd
        ? this.props.pcpSelected.pcpOfficeCd
        : this.props?.preEnrollInfo?.officeCd
        ? this.props.preEnrollInfo.officeCd
        : "",
      locationId: this.props.pcpSelected.PcpLocationId
        ? this.props.pcpSelected.PcpLocationId
        : this.props?.preEnrollInfo?.locationId
        ? this.props?.preEnrollInfo?.locationId
        : "",
      partAEffDate: moment(
        stateObj.data.partAEffDate,
        "MM/DD/YYYY",
        true
      ).isValid()
        ? // && stateObj?.partAvalid === true
          stateObj.data.partAEffDate
        : "",
      partBEffDate: moment(
        stateObj.data.partBEffDate,
        "MM/DD/YYYY",
        true
      ).isValid()
        ? //&& stateObj?.partBvalid === true
          stateObj.data.partBEffDate
        : "",
      ethnicityRace: stateObj.data.ethnicityRace,
      // premiumType:
      //   stateObj.data?.premiumType == "A"
      //     ? stateObj.data?.monthlybenefitsfrom != "" &&
      //       stateObj.data?.monthlybenefitsfrom != undefined &&
      //       stateObj.data?.monthlybenefitsfrom != null
      //       ? stateObj.data?.monthlybenefitsfrom
      //       : stateObj?.data?.premiumType
      //     : stateObj.data?.premiumType,
      // esrdInd: this.state.data.esrdInd,
      medicaidInd: stateObj.data.medicaidInd,
      medicaidId: stateObj.data.medicaidId?.slice(0, 20),
      //monthlybenefitsfrom: this.state.data?.monthlybenefitsfrom,
      termsAndConditions: stateObj.data?.termsAndConditions,
      applcat:
        stateObj.data.applcat === "E-ENROLL AGENT"
          ? "E-ENROLL AGENT"
          : stateObj.data.applcat === "E-ENROLL TELEPHONE"
          ? "E-ENROLL TELEPHONE"
          : "",
      ltcInd: stateObj.data?.ltcInd,
      nameOfInstitution: stateObj.data?.nameOfInstitution,
      addrOfInstitution: stateObj.data?.addrOfInstitution,
      // phoneOfInstitution:stateObj.data?.addrOfInstitution,
      premiumType: stateObj.data?.premiumType,
      acctholdername: stateObj.data?.acctholdername,
      bankname: stateObj.data?.bankname,
      routingNumber: stateObj.data?.routingNumber,
      accountNumber: stateObj.data?.accountNumber,
      acctType: stateObj.data?.acctType,
      retiree: stateObj.data?.retiree,
      retiredate:
        stateObj.data?.retiree === "Y" ? stateObj.data?.retiredate : "",
      retirename:
        stateObj.data?.retiree === "N" ? stateObj.data?.retirename : "",
      medicareEligible: stateObj.data?.medicareEligible,
      coveringSpouseOrDependent: stateObj.data?.coveringSpouseOrDependent,
      coveringSpouseOrDependentFirstName:
        stateObj.data?.coveringSpouseOrDependentFirstName,
      coveringSpouseOrDependentLastName:
        stateObj.data?.coveringSpouseOrDependentLastName,
      coveringSpouseOrDependentMiddleName:
        stateObj.data?.coveringSpouseOrDependentMiddleName,
      coveringSpouseOrDependentEmployeeName:
        stateObj.data?.coveringSpouseOrDependentEmployeeName,
      survivingSpouseCitySanDiegoRetiree:
        stateObj.data?.survivingSpouseCitySanDiegoRetiree,
      survivingSpouseCitySanDiegoRetireeFirstName:
        stateObj.data?.survivingSpouseCitySanDiegoRetireeFirstName,
      survivingSpouseCitySanDiegoRetireeLastName:
        stateObj.data?.survivingSpouseCitySanDiegoRetireeLastName,
      survivingSpouseCitySanDiegoRetireeMiddleName:
        stateObj.data?.survivingSpouseCitySanDiegoRetireeMiddleName,
      empCover: stateObj.data?.empCover ? stateObj.data?.empCover : "",
      dependentSpouse: stateObj.data?.dependentSpouse,
      dependentOther: stateObj.data?.dependentOther,
      esrdInd: stateObj.data?.esrdInd,
      esrdcontact: stateObj.data?.esrdcontact,
      // prescriptionDrug:stateObj.data?.ltcInd,
      agentId: "",
      agencyId: "",
      language: this.props.lang,
      planYear: this.props.year,
      attestationOther: stateObj.data?.attestationOther ?? "", // this belongs to ILS only , attestation other text box
      textIndicator: stateObj.data?.textIndicator ?? "", // this belongs to ILS only , related to email option indicator
      attestationMajorDisaster: stateObj.data?.attestationMajorDisaster ?? "", // this belongs to verda , attestation question section
      attestationElectionMissed: stateObj.data?.attestationElectionMissed ?? "", // this belongs to verda , attestation question section
      prefLngOthrValue: stateObj.data?.prefLngOthrValue ?? "", // for ILS only
    };
    return data2;
  };
  submitData = async () => {
    this.MailingandAuthCheck();
    if (this.mailingAddressFilled === true) {
      if (
        // !this.validator.check(this.state.data.cellPhoneNum, "phone") ||
        // !this.validator.check(this.state.data.otherPhone, "phone")
        (this.state.data.cellPhoneNum?.length != 10 &&
          this.state.data.cellPhoneNum?.length != 0) ||
        (this.state.data.otherPhone?.length != 10 &&
          this.state.data.otherPhone?.length != 0 &&
          this.state.data.otherPhone?.length != undefined)
      ) {
        this.setState({
          snackBarOpen: true,
          alertMsg:
            this.props.lang === "es"
              ? "Por favor ingrese el número de teléfono celular u otro número de teléfono correctamente."
              : "Please enter cell phone number or other phone number correctly.",
          severity: "error",
        });
        return;
      }
      if (this.state.data.mailingAddressRequired === "YES") {
        await this.setState({
          hrx: false,
        });
      } else {
        await this.setState({
          data: { ...this.state.data, mailingState: "" },
        });
      }
      // await this.setState({

      //   data: {
      //     ...this.state.data,
      //     medicareNumber:
      //       this.state.data.medicareNumber.slice(0, 4) +
      //       this.state.data.medicareNumber.slice(5, 8) +
      //       this.state.data.medicareNumber.slice(9),
      //   },
      // });

      // let payload = {
      //   ...this.state.data,
      //   productId: productId,
      //   pbpId: pbpId,
      //   langCode:this.props.lang,
      //   ethnicityRace:this.state.data.ethnicityRace.length===1?[]:this.state.data.ethnicityRace
      // };
      if (
        this.state.data.emailAddress === "" ||
        this.validator.check(this.state.data.emailAddress, "email")
      ) {
        let payload = this.getData(this.state);
        const response = await this.props.submitForm(payload);
        if (response?.status != "OK") {
          //let errormsg1=response?.message?response?.message:response?.data?.message
          this.setState({
            snackBarOpen: true,
            //alertMsg: errormsg1,
            alertMsg:
              this.props?.lang === "es"
                ? "Error del sistema. Inténtelo más tarde."
                : "System error. Please try later.",
            severity: "error",
          });
          return;
        }
        if (response.message === "SUCCESS") {
          let c = 0;
          let n = 0;
          let newcount = 0;
          // await this.props.setSpinner(true);
          for (let i = 0; i < this.state.selectedFiles.length; i++) {
            // Update the formData object
            if (this.state.selectedFiles[i].name !== undefined) {
              c = c + 1;
            }
          }
          if (this.state.selectedFiles.length) {
            const { preEnrollInfo, uploadedFilesInPreEnroll } = this.props;
            let prevSelectedFiles =
              preEnrollInfo?.attachmentList &&
              preEnrollInfo?.attachmentList?.length > 0
                ? [
                    ...preEnrollInfo.attachmentList.map(
                      (list) => list.attachmentName
                    ),
                    ...uploadedFilesInPreEnroll,
                  ]
                : uploadedFilesInPreEnroll;
            for (const selectedFile of this.state.selectedFiles) {
              if (
                selectedFile?.File?.name != undefined &&
                !prevSelectedFiles.includes(selectedFile?.File?.name)
              ) {
                newcount = newcount + 1;
                const formData2 = new FormData();

                // Update the formData object
                if (selectedFile.name !== undefined) {
                  const selectedIndex =
                    this.state.typeOfFilesToUpload?.findIndex(
                      (type) => type.label === selectedFile.name
                    );

                  formData2.append(
                    "attachment",
                    selectedFile.File,
                    selectedFile.File.name
                  );
                  formData2.append("appNumber", response.data);
                  formData2.append(
                    "attachmentType",
                    this.state.typeOfFilesToUpload[selectedIndex].typeCode
                  );
                  formData2.append("customerId", this.props?.customerId);
                  const resp = await this.props.uploadFile(formData2);
                  if (resp?.message != "SUCCESS") {
                    this.setState({
                      snackBarOpen: true,
                      alertMsg: resp?.message
                        ? resp?.message
                        : resp?.data?.message,
                      severity: "error",
                    });
                    return;
                  }
                  if (resp?.message === "SUCCESS") {
                    n = n + 1;
                  }
                }
              }
            }
          }
          //console.log("clsnewcount",newcount,"n",n,"c",c)
          if (newcount != 0) {
            if (n === c || c === this.props.uploadedFilesInPreEnroll?.length) {
              // await this.props.setSpinner(false);
              history.push("/e-Enroll/Confirmation");
            } else {
              this.setState({
                snackBarOpen: true,
                alertMsg:
                  this.props.lang === "es"
                    ? "Error del sistema."
                    : "System Error.",
                severity: "error",
              });
              return;
            }
          } else {
            history.push("/e-Enroll/Confirmation");
          }
        } else {
          if (response?.data?.message === "Application is already submitted") {
            this.setState({
              showpopUp: true,
            });
            return;
          }
          let msg =
            this.props.lang === "es" ? "Envío fallido" : "Submission Failed";
          this.setState({
            snackBarOpen: true,
            alertMsg: msg,
            severity: "error",
          });
        }
      } else {
        let msg =
          this.props.lang === "es"
            ? "Por favor ingrese una dirección de correo electrónico válida"
            : "Please Enter valid Email address";
        this.setState({
          snackBarOpen: true,
          alertMsg: msg,
          severity: "error",
        });
      }
    } else {
      this.setState({
        snackBarOpen: true,
        alertMsg:
          this.props.lang === "es"
            ? "Ingrese todos los campos para la dirección postal"
            : "Please enter all the fields for mailing address ",
        severity: "error",
      });
      return;
    }
  };

  saveData = async () => {
    // let payload={
    //   ...this.state.data,
    //   planYear:this.props.year
    // }
    let payload = this.getData(this.state);
    const response = await this.props.saveLogout(payload);
    if (response?.status != "OK") {
      //let errormsg=response?.message?response?.message:response?.data?.message
      this.setState({
        snackBarOpen: true,
        //alertMsg: errormsg,
        alertMsg:
          this.props?.lang === "es"
            ? "Error del sistema. Inténtelo más tarde."
            : "System error. Please try later.",
        severity: "error",
      });
      return;
    }
    if (response.message === "SUCCESS") {
      const { preEnrollInfo, uploadedFilesInPreEnroll } = this.props;
      let prevSelectedFiles =
        preEnrollInfo?.attachmentList &&
        preEnrollInfo?.attachmentList?.length > 0
          ? [
              ...preEnrollInfo.attachmentList.map(
                (list) => list.attachmentName
              ),
              ...uploadedFilesInPreEnroll,
            ]
          : uploadedFilesInPreEnroll;

      for (const selectedFile of this.state.selectedFiles) {
        if (!prevSelectedFiles.includes(selectedFile?.File?.name)) {
          const formData = new FormData();

          // Update the formData object
          if (selectedFile.name !== undefined) {
            const selectedIndex = this.state.typeOfFilesToUpload.findIndex(
              (type) => type.label === selectedFile.name
            );

            formData.append(
              "attachment",
              selectedFile.File,
              selectedFile.File.name
            );
            formData.append("appNumber", response.data);
            formData.append(
              "attachmentType",
              this.state.typeOfFilesToUpload[selectedIndex].typeCode
            );
            formData.append("customerId", this.props?.customerId);
            await this.props.uploadFile(formData);
          }
        }
      }
      // await this.props.removeplan();
      //alert("Saved successfully.");
      let index = response.data.indexOf("=") + 1;
      let id = response.data.slice(index, response.data.length);
      this.setState({
        snackBarOpen: true,
        alertMsg:
          this.props.lang === "es"
            ? "Identificación de la aplicación: " + id + ", guardada con éxito."
            : "Aplication Id : " + id + ", saved Successfully!",
        severity: "success",
        ethnicityRace: [],
      });
      setTimeout(() => {
        history.push("/e-Enroll/userLogin");
      }, 2000);
    } else {
      let msg = this.props.lang === "es" ? "Guardar fallida" : "Save Failed";
      this.setState({
        snackBarOpen: true,
        alertMsg: msg,
        severity: "error",
      });
    }
  };
  MailingandAuthCheck = async () => {
    const { mailingAddr, mailingCity, mailingzip } = this.state.data;

    this.mailingAddressFilled = true;
    if (mailingAddr || mailingCity || mailingzip) {
      if (mailingAddr && mailingCity && mailingzip) {
        this.mailingAddressFilled = true;
      } else {
        this.mailingAddressFilled = false;
      }
    }
  };
  redirect = async (event, Soa2) => {
    let id = event.target.id;
    let clickedSaveNextIds = this?.state?.clickedSaveNextIds;
    if (!clickedSaveNextIds.includes(id)) {
      clickedSaveNextIds.push(id);
      await this.props?.setStateParams(
        "clickedSaveNextIds",
        clickedSaveNextIds
      );
      this.setState({
        ...this.state,
        clickedSaveNextIds: clickedSaveNextIds,
      });
    }
    this.MailingandAuthCheck();
    if (this.mailingAddressFilled === true) {
      const payload2 = this.getData(this.state);
      //console.log("payload2=>",payload2)

      const response = await this.props.saveLogout(payload2);
      if (
        response.status === 500 &&
        response.data.message === "Application is already submitted"
      ) {
        this.setState({
          showpopUp: true,
        });
        return;
      }
      if (response?.status != "OK") {
        //let errormsg1=response?.message?response?.message:response?.data?.message
        this.setState({
          snackBarOpen: true,
          // alertMsg: errormsg1,
          alertMsg:
            this.props?.lang === "es"
              ? "Error del sistema. Inténtelo más tarde."
              : "System error. Please try later.",
          severity: "error",
        });
        return;
      }
      // if (this.state.selectedFiles.length && isNaN(response.data) === true) {
      //   this.setState({
      //     snackBarOpen: true,
      //     alertMsg:
      //       this.props.lang === "es"
      //         ? "Por favor complete los detalles básicos como Nombre y Número de Medicare para guardar Archivos/Firma"
      //         : "Kindly fill basic details like First Name & Medicare Number to save Files/Signature",
      //     severity: "error",
      //   });
      // }
      //  else {
      let c = 0;
      let n = 0;
      for (const element of this.state.selectedFiles) {
        // Update the formData object
        if (element.name !== undefined) {
          c = c + 1;
        }
      }
      if (this.state.selectedFiles.length) {
        const { preEnrollInfo, uploadedFilesInPreEnroll } = this.props;
        let prevSelectedFiles =
          preEnrollInfo?.attachmentList &&
          preEnrollInfo?.attachmentList?.length > 0
            ? [
                ...preEnrollInfo.attachmentList.map(
                  (list) => list.attachmentName
                ),
                ...uploadedFilesInPreEnroll,
              ]
            : uploadedFilesInPreEnroll;
        for (const selectedFile of this.state?.selectedFiles) {
          if (!prevSelectedFiles.includes(selectedFile?.File?.name)) {
            const formData2 = new FormData();
            // Update the formData object
            if (selectedFile.name !== undefined) {
              const selectedIndex = this.state.typeOfFilesToUpload?.findIndex(
                (type) => type.label === selectedFile.name
              );

              formData2.append(
                "attachment",
                selectedFile.File,
                selectedFile.File.name
              );
              formData2.append("appNumber", response.data);
              formData2.append(
                "attachmentType",
                this.state.typeOfFilesToUpload[selectedIndex].typeCode
              );
              formData2.append("customerId", this.props?.customerId);
              const resp = await this.props.uploadFile(
                formData2,
                selectedFile?.File?.name
              );
              if (resp?.message !== "SUCCESS") {
                this.setState({
                  snackBarOpen: true,
                  alertMsg:
                    this.props.lang === "es"
                      ? "Error del sistema."
                      : "System Error.",
                  severity: "error",
                });
              }
            }
          }
        }
        // if (n !== c) {
        //   this.setState({
        //     snackBarOpen: true,
        //     alertMsg:
        //       this.props.lang === "es" ? "Error del sistema." : "System Error.",
        //     severity: "error",
        //   });
        // }
      }
      // }
      if (Soa2 != undefined) {
        this.setState({
          isSoaFilled: true,
        });
      }
      if (id === "next0") {
        await this.setState({ stepVal: "step1", SOA: Soa2 });
      }
      if (id === "next2") {
        await this.setState({ stepVal: "step3" });
      }
      if (id === "next1") {
        await this.setState({ stepVal: "step2" });
      }
      if (id === "next3") {
        let step;
        if (
          this.props.productCategory === "INDIVIDUAL" ||
          this.props.productCategory === "GROUP"
        ) {
          step = "step1";
        } else {
          step = "step4";
        }
        await this.setState({ stepVal: step });
      }
      if (id === "next4") {
        let step = this.props.agentLogin ? "step5" : "step1";
        await this.setState({ stepVal: step });
      }
      if (id === "next5") {
        await this.setState({ stepVal: "step1" });
      }
    } else {
      this.setState({
        snackBarOpen: true,
        alertMsg:
          this.props.lang === "es"
            ? "Ingrese todos los campos para la dirección postal"
            : "Please enter all the fields for mailing address ",
        severity: "error",
      });
      return;
    }
  };

  formatPhoneNumber = (phoneNumberString) => {
    var match = phoneNumberString.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      // return "(" + match[1] + ") " + match[2] + "-" + match[3];
      return match[1] + match[2] + match[3];
    }
    return phoneNumberString;
  };
  handleNumberChange = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    value = value.replace(/[^0-9]/g, "");

    this.setState({ data: { ...this.state.data, [name]: value } });
    let flag = this.props.agentLogin ? true : false;
    await this.props.captchaValidation(flag);
  };

  handleDate = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    value = handleDateChange(value);
    await this.setState({
      data: { ...this.state.data, [name]: value },
    });
    let flag = this.props.agentLogin ? true : false;
    await this.props.captchaValidation(flag);
  };
  handleChange = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    // let id = event.target.id;

    // if (id === "lfp_braille" || id === "lfp_largeprint" || id === "lfp_spanish") {
    // if(document.getElementById("otherlanguageValue")){
    //   document.getElementById("otherlanguageValue").value = "";
    // }

    // }

    if (name.toLowerCase().includes("phone")) {
      value = this.formatPhoneNumber(value.replace(/[^0-9]/g, ""));
    }

    if (
      event.target.type === "checkbox" &&
      (name !== "language" || name !== "languageCheck") &&
      name !== "prefLng"
    ) {
      value = event.target.checked ? "Y" : "N";
    }
    if (name === "prefLng") {
      value = event.target.checked ? event.target.value : "";
      // let accessValFlag=["lfp_braille","lfp_largeprint","lfp_spanish"].some((e2)=>e2===event.target.id)
      //this.setState({...this.state,data:{...this.state.data,[name]:value,["accessibleFormatVal"]:accessValFlag?"":(this.state.data.accessibleFormatVal??"")}})
      this.setState({
        ...this.state,
        data: { ...this.state.data, [name]: value },
      });
      return;
    }
    if (name === "accessibleFormatVal") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: this.state.data.accessibleFormatVal === value ? "" : value,
        },
      });
      return;
    }
    if (name === "renalDisease" && value === "N") {
      this.setState({
        data: { ...this.state.data, [name]: value, esrdcontact: "" },
      });
      return;
    }

    if (name === "medicareNumber") {
      let c = 0;

      if (value.includes("-") || value.length > 11) {
        value = value.replace(/-/g, "");
        value = value.slice(0, 11);
      }
      if (value.length === 11 && value.indexOf("-") === -1) {
        value =
          value.slice(0, 4) + "-" + value.slice(4, 7) + "-" + value.slice(7);
      }
      let check = value.replace(/-/g, "");
      if (check.length < 11) {
        value = check;
      }
      for (let i = 0; i < value.length; i++) {
        if (value[i] === "-") {
          c = c + 1;
        }
      }
      if (check.length === 11 && c < 2) {
        value = check;
        value =
          value.slice(0, 4) + "-" + value.slice(4, 7) + "-" + value.slice(7);
      }
      value = value.toUpperCase();
    }

    if (name === "isDrugCoverage" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          nameOfCoverage: "",
          covMemberNumber: "",
          covGroupNumber: "",
        },
      });
      return;
    }

    if (name === "medicaidprg" && value === "N") {
      this.setState({
        data: { ...this.state.data, [name]: value, medicaidNbr: "" },
      });
      return;
    }
    if (name === "ltcInd" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          nameOfInstitution: "",
          addrOfInstitution: "",
          // addrOfInst: "",
        },
      });
      return;
    }
    if (name === "RETIREE" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          retiredate: "",
          coveringSpouseOrDependent: "",
          coveringSpouseOrDependentEmployeeName: "",
          coveringSpouseOrDependentMiddleName: "",
          coveringSpouseOrDependentFirstName: "",
          coveringSpouseOrDependentLastName: "",
        },
      });
      return;
    }
    if (name === "RETIREE" && value === "Y") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          retirename: "",
          survivingSpouseCitySanDiegoRetiree: "",
          survivingSpouseCitySanDiegoRetireeLastName: "",
          survivingSpouseCitySanDiegoRetireeFirstName: "",
          survivingSpouseCitySanDiegoRetireeMiddleName: "",
        },
      });
      return;
    }

    if (name === "coveringSpouseOrDependent" && value === "Y") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          coveringSpouseOrDependentEmployeeName: "",
        },
      });
      return;
    }
    if (name === "coveringSpouseOrDependent" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          coveringSpouseOrDependentMiddleName: "",
          coveringSpouseOrDependentFirstName: "",
          coveringSpouseOrDependentLastName: "",
        },
      });
      return;
    }
    if (name === "coveringSpouseOrDependentEmployeeName" && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          survivingSpouseCitySanDiegoRetireeLastName: "",
          survivingSpouseCitySanDiegoRetireeFirstName: "",
          survivingSpouseCitySanDiegoRetireeMiddleName: "",
        },
      });
      return;
    }
    if ((name === "empCover" || name === "meddependsp") && value === "N") {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          dependentSpouse: "",
          dependentOther: "",
        },
      });
      return;
    }
    if (name.toLowerCase().includes("filetype")) {
      value = event.target ? event.target.value : event.value;
      this.setState({
        fileType: value,
      });
    }
    if (name.toLowerCase().includes("fileupload")) {
      let otherType = this.state.selectedFiles.filter(
        (file1) =>
          file1?.name === "OTHERS" || file1?.attachmentType === "OTHERS"
      );
      let filetype = this.state.fileType;
      if (otherType?.length === 3 && filetype === "misc") {
        this.setState({
          ...this.state,
          fileType: "",
          snackBarOpen: true,
          alertMsg:
            this.props.lang === "es"
              ? "Se pueden cargar un máximo de tres Otro tipo"
              : "Maximum three Other Type can be uploaded",
          severity: "warning",
        });
        return;
      }

      let file = event.target ? event.target.files[0] : event.files[0];
      let fileSize = (file.size * 0.001) / 1024;
      if (fileSize > 25) {
        this.setState({
          snackBarOpen: true,
          alertMsg: "Please upload a file having less than 25 MB size",
          severity: "error",
        });
        return;
      }
      let url = URL.createObjectURL(event.target.files[0]);
      // window.open(url)
      let fileName = this.state.typeOfFilesToUpload.filter(
        (data1) => data1.value === filetype
      )[0];
      let files = this.state.selectedFiles;
      if (filetype !== "misc") {
        files = this.state.selectedFiles.filter((file1) => {
          if (file1.name) {
            return file1.name !== fileName.label;
          } else {
            return file1.attachmentType !== fileName.label;
          }
        });
      }

      let dataCopy = this.state.data;
      let urlArray = this.state.urlList;
      this.setState((prevState) => ({
        ...prevState,
        url: url,
        urlList: [...urlArray, { url: url, name: fileName.label }],
        selectedFiles: [...files, { File: file, name: fileName.label }],
      }));

      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = (e) => {
        this.setState((prevState) => ({
          ...prevState,
          selectedFiles: [...files, { File: file, name: fileName.label }],
          fileType: "",
          data: { ...dataCopy, [filetype]: e.target.result },
        }));
      };
    }
    if (/^\s/g.test(value)) {
      value = value.replace(/^\s+/, "");
    }
    await this.setState({ data: { ...this.state.data, [name]: value } });
    let flag = this.props.agentLogin ? true : false;
    await this.props.captchaValidation(flag);
  };
  handleStepCheckbox = async (event) => {
    let value = event.target.value;
    let name = event.target.name;
    let ethnicity1 = this.state.data.ethnicityRace;
    if (ethnicity1.some((item) => item.piValue === value)) {
      ethnicity1 = ethnicity1.filter((item) => item.piValue !== value);
    } else {
      if (
        ethnicity1.some((item) => item.piValue === "999") &&
        name === "RACE"
      ) {
        return;
      }
      if (
        ethnicity1.some((item) => item.piValue === "NR") &&
        name === "ETHNICITY"
      ) {
        return;
      }
      ethnicity1.push({ piCode: name, piValue: value });
      if (value === "999" && name === "RACE") {
        ethnicity1 = ethnicity1.filter(
          (item) => item.piValue === value || item.piCode === "ETHNICITY"
        );
      }
      if (value === "NR" && name === "ETHNICITY") {
        ethnicity1 = ethnicity1.filter(
          (item) => item.piValue === value || item.piCode === "RACE"
        );
      }
    }

    await this.setState({
      data: { ...this.state.data, ethnicityRace: ethnicity1 },
    });
  };
  getLabel = (value) => {
    let obj = this.props.physicians;
    let label = obj.find((el) => el.value === value);

    return label.label;
  };
  pcpChange = async (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const plan = this.state.selectedPlan;
    let label = await this.getLabel(value);
    if (plan !== "SDAHMO1" && plan !== "SDAHMO20") {
      const data = await this.props.getClinicalName(value);
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
          pcpMedicalGroupName: data.data,
          pcpNameLabel: label,
        },
      });
    } else {
      this.setState({
        data: {
          ...this.state.data,
          [name]: value,
        },
      });
    }
    let flag = this.props.agentLogin ? true : false;
    await this.props.captchaValidation(flag);
  };
  setRuLanguage = async () => {
    if (lang === "en") {
      await setLanguage("es");
      lang = "es";
    } else {
      await setLanguage("en");
      lang = "en";
    }
  };
  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      snackBarOpen: false,
    });
  };
  setSnackBar = (msg) => {
    this.setState({
      snackBarOpen: true,
      alertMsg: msg,
      severity: "error",
    });
  };
  setQSNS = (attestationList, dateInd) => {
    let getSubqnId = attestationList.map((qs) => {
      return this.props.qsns.filter((el) => el.questionId === qs.qsnMetaId);
    });
    // return this.props.qsns[qs.qsnMetaId - 1]?.answersvo[0]?.subQuestions;

    //let getSubQIds = SubqnId.map((ids)=>ids?.answersvo[0].subQuestions)

    let SubqnId = [];
    for (let i = 0; i < getSubqnId.length; i++) {
      SubqnId.push(getSubqnId[i][0].answersvo[0]?.subQuestions);
    }
    let DateUpdated = [];
    DateUpdated = this.state?.questionDate.filter((qsn) => {
      if (SubqnId.includes(qsn.qsnMetaId)) {
        return qsn;
      }
    });
    if (dateInd.length !== 0) {
      this.setState({
        ...this.state,
        attestationList: attestationList,
        dateInd: dateInd,
        questionDate: DateUpdated,
      });
    } else {
      this.setState({
        ...this.state,
        data: { ...this.state.data, questionDate: "" },
        attestationList: attestationList,
        dateInd: [{ dateInd: "n" }],
        questionDate: DateUpdated,
      });
    }
  };
  handleDatesAttestation = (fieldId, currentDateid) => {
    DateUtil.getDatePicker("#" + fieldId).datepicker("show");
    DateUtil.getDatePicker("#" + fieldId).on("change", (e) => {
      this.setDatesAttestation(fieldId, e.target.value, currentDateid);
      DateUtil.getDatePicker("#" + fieldId).datepicker("refresh");
    });
  };

  qsnsDate = async (currentDateid) => {
    //let currentDateid = this.props.qsns[qsnsid - 1]?.answersvo[0]?.subQuestions
    await this.props.setStateParams("currentDateid", currentDateid);
    this.handleDatesAttestation(currentDateid, currentDateid);
  };
  setDatesAttestation = async (fieldId, value, currentDateid) => {
    let dateArray = this.state.questionDate;
    //this.dateArray = this.state.questionDate;
    if (dateArray.some((date) => date.qsnMetaId === currentDateid)) {
      // let index = this.dateArray.findIndex(
      //   (el) => el.qsnMetaId === currentDateid
      // );
      let index;
      for (let i = 0; i < dateArray.length; i++) {
        if (dateArray[i].qsnMetaId === currentDateid) {
          index = i;
          break;
        }
      }
      dateArray.splice(index, 1);
    }
    dateArray.push({ qsnMetaId: currentDateid, answer: value });

    let attestationArray = this.state.attestationList.filter(
      (qs) => qs.answer === "yes"
    );

    let finalAttestation = attestationArray.concat(dateArray);
    await this.setState({
      ...this.state,
      attestationList: finalAttestation,
      questionDate: dateArray,
    });
  };
  handleAttestationDate = async (event, currentDateid) => {
    // let name = event.target.name;
    let value = event.target.value;

    value = handleDateChange(value);

    if (value === "") {
      this.setState({
        snackBarOpen: true,
        alertMsg:
          this.props.lang === "es"
            ? "Ingrese la fecha en el formato MM/DD/YYYY"
            : "Please enter date in the MM/DD/YYYY format",
        severity: "error",
      });
    }
    await this.props.setStateParams("currentDateid", currentDateid);
    this.setDatesAttestation("", value, currentDateid);
    // await this.setState({
    //   data: { ...this.state.data, [name]: value },
    // });
  };

  checkEligibility = async () => {
    const { medicareNumber, birthDate } = this.state.data;
    if (medicareNumber === "" || birthDate === "") {
      this.setState({
        snackBarOpen: true,
        alertMsg:
          this.props.lang === "es"
            ? "¡Los campos Número de Medicare y Fecha de nacimiento son obligatorios!"
            : "Fields Medicare Number & Date of Birth are required!",
        severity: "error",
      });
    } else {
      let payload = {
        mbi: medicareNumber,
        //lastName: lastName,
        dob: birthDate,
        customerId: this.props?.customerId,
      };
      let response = await this.props.checkEligibility(payload);
      let msg =
        response.data.eligible === true
          ? "Medicare ID verified"
          : response.data.errorMessage;
      let severity = response.data.eligible === true ? "success" : "error";
      this.setState({
        snackBarOpen: true,
        alertMsg: msg,
        severity: severity,
      });

      if (
        response.data.partAEffDate != null &&
        response.data.partBEffDate != null
      ) {
        let partAEffDate = new Date(
          response.data.partAEffDate
        ).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
        let partBEffDate = new Date(
          response.data.partBEffDate
        ).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });

        this.setState({
          data: {
            ...this.state.data,
            partAEffDate: partAEffDate,
            partBEffDate: partBEffDate,
          },
        });
      }
    }
    // let date = new Date();
    // let currentYear = date.getFullYear();
    // let age = currentYear - this.state.data.birthDate.slice(6, 10);
    // if (age >= 65) alert("You are Eligible! Please Continue.");
    // else alert("Oops! You are not eligible!");
  };
  viewFile = async (index, name, e) => {
    let viewurl = this.state.urlList[index]?.url;
    if (viewurl === undefined) {
      e.preventDefault();
      const payload = {
        appNumber: this?.props?.appNum,
        customerId: this?.props?.customerId,
        attachmentType: name.split("_")[1],
        attachmentName: name.split("\\")[5],
      };
      const response = await this?.props.downloadFormsPdf(payload);
      if (response.status === "OK") {
        const blob = "data:application/pdf;base64," + response.data;
        saveAs(blob, name);
      }
      // await this.setState({
      //   snackBarOpen: true,
      //   alertMsg: "cannot view the file",
      //   severity: "error",
      // });
    }
    this.setState({
      ...this.state,
      viewurl: viewurl,
    });
  };
  removeFile = async (index, name) => {
    let files = this.state.selectedFiles;
    let urlArray = this.state.urlList;
    // if data  available in the Backend, thn removing
    if (
      this.props.preEnrollInfo.attachmentList !== undefined &&
      this.props.preEnrollInfo.attachmentList.length > 0
    ) {
      let isavailable = false;
      for (let i = 0; i < this.props.preEnrollInfo.attachmentList.length; i++) {
        if (
          this.props.preEnrollInfo.attachmentList[i].attachmentName === name
        ) {
          isavailable = true;
          break;
        }
      }
      if (isavailable === true) {
        await this.props.deleteFile({
          appNumber: this.props.preEnrollInfo.appNumber,
          attachmentId: this.state.selectedFiles[index].attachmentId,
          attachmentName: this.state.selectedFiles[index].attachmentName,
          customerId: this.props?.customerId,
        });
      }
    }
    files = files.filter((file, index1) => index1 !== index);
    urlArray.splice(index, 1);
    // urlArray.splice(index,1);
    this.setState((prevState) => ({
      ...prevState,
      selectedFiles: files,
      urlList: urlArray,
      data: { ...this.state.data, [name]: "" },
    }));
  };
  handleChangeCategory = (name) => (event) => {
    let value = "";
    value = event.target ? event.target.value : event.value;
    this.setState((prevState) => ({
      ...prevState,
      data: { ...prevState.data, [name]: value },
    }));
  };
  Okhandler = () => {
    this.setState({
      showpopUp: false,
    });
    this.props.setStateParams("storeshowpopUp", false);
    // window.location.href =
    //   `http://localhost:3009/e-Enroll/userLogin`
    // ;
    history.push("/e-Enroll/userLogin");
  };
  render() {
    const {
      productCategory,
      // year
    } = this.props;
    const {
      data,
      // selectedPlan,
      snackBarOpen,
      severity,
      alertMsg,
      vertical,
      horizontal,
    } = this.state;
    let checkedQuestions = this.state.attestationList?.filter(
      (x) => x?.answer === "yes"
    );
    let questionDates = this.state.attestationList?.filter(
      (x) => x?.answer !== "yes"
    );
    let allDatesValid = true;
    for (const element of questionDates) {
      if (!moment(element?.answer, "MM/DD/YYYY", true).isValid()) {
        allDatesValid = false;
        break;
      }
    }
    let info = this.props.qsns?.filter((x) => {
      for (const element of checkedQuestions) {
        if (x?.questionId === element?.qsnMetaId) {
          return x;
        }
      }
    });
    let numOfDateCheckBoxes = info.filter((z) => {
      if (z.answersvo.length > 0) {
        return z;
      }
    });
    let count = "";
    let progress = "";
    if (productCategory === "INDIVIDUAL" || productCategory === "RETIREE") {
      count =
        this.state.data.mailingAddressRequired === "YES"
          ? data.isDrugCoverage === "Y"
            ? data.ltcInd === "Y"
              ? 37
              : 36
            : data.ltcInd === "Y"
            ? 34
            : 33
          : data.isDrugCoverage === "Y"
          ? data.ltcInd === "Y"
            ? 34
            : 33
          : data.ltcInd === "Y"
          ? 31
          : 30;
      let progress32, progress33, progress34;
      if (this.state.data.mailingAddressRequired === "YES") {
        progress32 = data.mailingCity === "" ? 0 : 1;
        progress33 = data.mailingAddr === "" ? 0 : 1;
        progress34 =
          data.mailingzip === "" || data.mailingzip?.length < 5 ? 0 : 1;
      }
      let progress46, progress47, progress48;
      if (productCategory === "RETIREE") {
        progress46 =
          data.proposedEffDate === "" ||
          this.state?.proposedvalid === false ||
          !moment(data.proposedEffDate, "MM/DD/YYYY", true).isValid()
            ? 0
            : 1;
        progress47 =
          data.partAEffDate === "" ||
          !moment(data.partAEffDate, "MM/DD/YYYY", true).isValid()
            ? 0
            : 1;
        progress48 =
          data.partBEffDate === "" ||
          !moment(data.partBEffDate, "MM/DD/YYYY", true).isValid()
            ? 0
            : 1;
        count = count + 3;
      }
      const progress1 = data.firstName === "" ? 0 : 1;
      const progress2 = data.lastName === "" ? 0 : 1;
      const progress3 =
        data.birthDate === "" ||
        !moment(data.birthDate, "MM/DD/YYYY", true).isValid()
          ? 0
          : 1;

      const progress4 =
        data.primaryPhoneNum === "" || data.primaryPhoneNum?.length < 10
          ? 0
          : 1;
      const progress5 = data.permanentAddrStreet === "" ? 0 : 1;
      const progress6 = data.permanentCity === "" ? 0 : 1;
      const progress7 =
        data.permanentZip === "" || data.permanentZip?.length < 5 ? 0 : 1;
      const progress8 = data.sex === "" ? 0 : 1;
      const progress9 =
        data.medicareNumber === "" || data.medicareNumber?.length < 11 ? 0 : 1;

      const progress10 =
        this.props.pcpSelected?.pcpName || this.props.preEnrollInfo?.pcpName
          ? 1
          : 0;

      const progress12 = data.name === "" ? 0 : 1;

      const progress13 =
        data.isAuthRepresentative === "Y" && data.nameOfRep !== "" ? 1 : 0;
      const progress14 =
        data.isAuthRepresentative === "Y" && data.relationOfRep !== "" ? 1 : 0;
      const progress15 =
        data.isAuthRepresentative === "Y" &&
        (data?.addressOfRep === "" ||
          data?.addressOfRep === undefined ||
          data?.addressOfRep === null)
          ? 0
          : 1;
      const progress16 =
        data.isAuthRepresentative === "Y" &&
        data.phoneNumberOfRep !== "" &&
        data.phoneNumberOfRep?.length === 10
          ? 1
          : 0;
      const progress17 =
        data.isLicensedSalesRep === "Y" && data.salRepName !== "" ? 1 : 0;
      const progress35 =
        data.isDrugCoverage === "Y" && data.nameOfCoverage !== "" ? 1 : 0;
      const progress36 =
        data.isDrugCoverage === "Y" && data.covMemberNumber !== "" ? 1 : 0;
      const progress37 =
        data.isDrugCoverage === "Y" && data.covGroupNumber !== "" ? 1 : 0;
      const progress38 =
        data?.ltcInd === "Y" &&
        data.nameOfInstitution !== "" &&
        data.addrOfInstitution !== ""
          ? 1
          : 0;
      const progress18 = data.c2 === "MOV" && data.attestation2 !== "" ? 1 : 0;
      const progress19 = data.c3 === "INC" && data.attestation3 !== "" ? 1 : 0;
      const progress20 = data.c4 === "RUS" && data.attestation4 !== "" ? 1 : 0;
      const progress21 = data.c5 === "LAW" && data.attestation5 !== "" ? 1 : 0;
      const progress22 = data.c8 === "NLS" && data.attestation8 !== "" ? 1 : 0;
      const progress23 = data.c9 === "LTC" && data.attestation9 !== "" ? 1 : 0;
      const progress24 =
        data.c10 === "PAC" && data.attestation10 !== "" ? 1 : 0;
      const progress25 =
        data.c11 === "LCC" && data.attestation11 !== "" ? 1 : 0;
      const progress26 =
        data.c12 === "LEC" && data.attestation12 !== "" ? 1 : 0;
      const progress27 =
        data.c15 === "SNP" && data.attestation15 !== "" ? 1 : 0;
      const progress28 =
        data.c22 === "MCD" && data.recentlyChangeMedicaid !== "" ? 1 : 0;
      const progress49 =
        questionDates.length === numOfDateCheckBoxes.length &&
        allDatesValid === true
          ? 1
          : 0;
      if (
        (data.attestation2 === "" ||
          !moment(data.attestation2, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation3 === "" ||
          !moment(data.attestation3, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation4 === "" ||
          !moment(data.attestation4, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation5 === "" ||
          !moment(data.attestation5, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation8 === "" ||
          !moment(data.attestation8, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation9 === "" ||
          !moment(data.attestation9, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation10 === "" ||
          !moment(data.attestation10, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation11 === "" ||
          !moment(data.attestation11, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation12 === "" ||
          !moment(data.attestation12, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation15 === "" ||
          !moment(data.attestation15, "MM/DD/YYYY", true).isValid()) &&
        (data.recentlyChangeMedicaid === "" ||
          !moment(data.recentlyChangeMedicaid, "MM/DD/YYYY", true).isValid()) &&
        (data.attestation7 === "" ||
          !moment(data.attestation7, "MM/DD/YYYY", true).isValid())
      ) {
        count -= 13;
      } else {
        count -= 11;
      }
      if (data.isAuthRepresentative !== "Y") count -= 3;
      if (data.isLicensedSalesRep !== "Y") count -= 1;
      progress =
        ((progress1 +
          progress2 +
          progress3 +
          progress4 +
          progress5 +
          progress6 +
          progress7 +
          progress8 +
          progress9 +
          progress10 +
          progress12 +
          progress13 +
          progress14 +
          progress15 +
          progress16 +
          progress17 +
          progress18 +
          progress19 +
          progress20 +
          progress21 +
          progress22 +
          progress23 +
          progress24 +
          progress25 +
          progress26 +
          progress27 +
          progress28 +
          progress49 +
          (productCategory === "RETIREE" ? progress46 : 0) +
          (productCategory === "RETIREE" ? progress47 : 0) +
          (productCategory === "RETIREE" ? progress48 : 0) +
          (data.isDrugCoverage === "Y"
            ? progress35 + progress36 + progress37
            : 0) +
          (data.ltcInd === "Y" ? progress38 : 0) +
          (this.state.data.mailingAddressRequired === "YES"
            ? progress32 + progress33 + progress34
            : 0)) /
          count) *
        100;
    } else {
      count =
        this.state.data.mailingAddressRequired === "YES"
          ? data.ltcInd === "Y"
            ? 39
            : 38
          : data.ltcInd === "Y"
          ? 36
          : 35;
      let progress32, progress33;
      if (productCategory !== "RETIREE") {
        progress32 =
          data.proposedEffDate === "" || this.state?.proposedvalid === false ||
          !moment(data.proposedEffDate, "MM/DD/YYYY", true).isValid()
            ? 0
            : 1;
        progress33 = data.Socialnumber?.length != 9 ? 0 : 1;
      }

      const progress1 = data.firstName === "" ? 0 : 1;
      const progress2 = data.lastName === "" ? 0 : 1;
      const progress3 =
        data.birthDate === "" ||
        !moment(data.birthDate, "MM/DD/YYYY", true).isValid()
          ? 0
          : 1;

      const progress4 = data.primaryPhoneNum === "" ? 0 : 1;
      const progress5 = data.permanentAddrStreet === "" ? 0 : 1;
      const progress6 = data.permanentCity === "" ? 0 : 1;
      const progress7 =
        data.permanentZip === "" || data.permanentZip?.length < 5 ? 0 : 1;
      const progress8 = data.sex === "" ? 0 : 1;
      const progress9 =
        data.medicareNumber === "" || data.medicareNumber?.length < 11 ? 0 : 1;

      const progress10 =
        data.partAEffDate === "" ||
        !moment(data.partAEffDate, "MM/DD/YYYY", true).isValid()
          ? 0
          : 1;
      const progress11 =
        data.partBEffDate === "" ||
        !moment(data.partBEffDate, "MM/DD/YYYY", true).isValid()
          ? 0
          : 1;

      const progress12 =
        this.props.pcpSelected?.pcpName || this.props.preEnrollInfo?.pcpName
          ? 1
          : 0;
      const progress13 = data.name === "" ? 0 : 1;
      const progress14 =
        data.isAuthRepresentative === "Y" && data.nameOfRep !== "" ? 1 : 0;
      const progress15 =
        data.isAuthRepresentative === "Y" && data.relationOfRep !== "" ? 1 : 0;
      const progress16 =
        data.isAuthRepresentative === "Y" &&
        (data?.addressOfRep !== "" ||
          data?.addressOfRep !== undefined ||
          data?.addressOfRep !== null)
          ? 1
          : 0;
      const progress17 =
        data.isAuthRepresentative === "Y" &&
        data.phoneNumberOfRep !== "" &&
        data.phoneNumberOfRep?.length === 10
          ? 1
          : 0;
      const progress18 =
        data.isLicensedSalesRep === "Y" && data.salRepName !== "" ? 1 : 0;
      const progress35 =
        data.isDrugCoverage === "Y" && data.nameOfCoverage !== "" ? 1 : 0;
      const progress36 =
        data.isDrugCoverage === "Y" && data.covMemberNumber !== "" ? 1 : 0;
      const progress37 =
        data.isDrugCoverage === "Y" && data.covGroupNumber !== "" ? 1 : 0;
      const progress19 = data.c2 === "MOV" && data.attestation2 !== "" ? 1 : 0;
      const progress20 = data.c3 === "INC" && data.attestation3 !== "" ? 1 : 0;
      const progress21 = data.c4 === "RUS" && data.attestation4 !== "" ? 1 : 0;
      const progress22 = data.c5 === "LAW" && data.attestation5 !== "" ? 1 : 0;
      const progress23 = data.c8 === "NLS" && data.attestation8 !== "" ? 1 : 0;
      const progress24 = data.c9 === "LTC" && data.attestation9 !== "" ? 1 : 0;
      const progress25 =
        data.c10 === "PAC" && data.attestation10 !== "" ? 1 : 0;

      const progress26 =
        data.c11 === "LCC" && data.attestation11 !== "" ? 1 : 0;
      const progress27 =
        data.c12 === "LEC" && data.attestation12 !== "" ? 1 : 0;
      const progress28 =
        data.c15 === "SNP" && data.attestation15 !== "" ? 1 : 0;
      const progress29 =
        data.c16 === "OTH" &&
        (data.c16Attestation !== "" || data.attestation16 !== "")
          ? 1
          : 0;
      const progress42 =
        questionDates.length === numOfDateCheckBoxes.length &&
        allDatesValid === true
          ? 1
          : 0;
      // if ( SONAR FIX AS BOTH IF ELSE HAVE SAME LINE COUNT-=11
      //   (data.attestation2 === "" ||
      //     !moment(data.attestation2, "MM/DD/YYYY", true).isValid()) &&
      //   (data.attestation3 === "" ||
      //     !moment(data.attestation3, "MM/DD/YYYY", true).isValid()) &&
      //   (data.attestation4 === "" ||
      //     !moment(data.attestation4, "MM/DD/YYYY", true).isValid()) &&
      //   (data.attestation5 === "" ||
      //     !moment(data.attestation5, "MM/DD/YYYY", true).isValid()) &&
      //   (data.attestation8 === "" ||
      //     !moment(data.attestation8, "MM/DD/YYYY", true).isValid()) &&
      //   (data.attestation9 === "" ||
      //     !moment(data.attestation9, "MM/DD/YYYY", true).isValid()) &&
      //   (data.attestation10 === "" ||
      //     !moment(data.attestation10, "MM/DD/YYYY", true).isValid()) &&
      //   (data.attestation11 === "" ||
      //     !moment(data.attestation11, "MM/DD/YYYY", true).isValid()) &&
      //   (data.attestation12 === "" ||
      //     !moment(data.attestation12, "MM/DD/YYYY", true).isValid()) &&
      //   data.attestation15 === "" &&
      //   (data.c16Attestation === "" ||
      //     !moment(data.attestation16, "MM/DD/YYYY", true).isValid())
      // ) {
      //   count -= 11;
      // } else {
      count -= 11;
      // }
      if (data.isAuthRepresentative !== "Y") count -= 4;
      if (data.isLicensedSalesRep !== "Y") count -= 1;
      if (data.isDrugCoverage !== "Y") count -= 3;
      let progress38, progress39, progress40;
      if (this.state.data.mailingAddressRequired === "YES") {
        progress38 = data.mailingCity === "" ? 0 : 1;
        progress39 = data.mailingAddr === "" ? 0 : 1;
        progress40 = data.mailingzip === "" ? 0 : 1;
      }
      const progress41 =
        data?.ltcInd === "Y" &&
        data.nameOfInstitution !== "" &&
        data.addrOfInstitution !== ""
          ? 1
          : 0;
      progress =
        ((progress1 +
          progress2 +
          progress3 +
          progress4 +
          progress5 +
          progress6 +
          progress7 +
          progress8 +
          progress9 +
          progress10 +
          progress11 +
          progress12 +
          progress13 +
          progress14 +
          progress15 +
          progress16 +
          progress17 +
          progress18 +
          progress19 +
          progress20 +
          progress21 +
          progress22 +
          progress23 +
          progress24 +
          progress25 +
          progress26 +
          progress27 +
          progress28 +
          progress29 +
          progress35 +
          progress32 +
          progress33 +
          progress36 +
          progress37 +
          progress42 +
          (this.state.data.mailingAddressRequired === "YES"
            ? progress38 + progress39 + progress40
            : 0) +
          (data.ltcInd === "Y" ? progress41 : 0)) /
          count) *
        100;

      // console.log("watching=>","progress1" ,progress1,
      // "progress2" ,progress2,
      // "progress3" ,progress3,
      // "progress4" ,progress4,
      // "progress5" ,progress5,
      // "progress6" ,progress6,
      // "progress7" ,progress7,
      // "progress8" ,progress8,
      // "progress9" ,progress9,
      // "progress10" ,progress10,
      // "progress11" ,progress11,
      // "progress12" ,progress12,
      // "progress13" ,progress13,
      // "progress14" ,progress14,
      // "progress15" ,progress15,
      // "progress16" ,progress16,
      // "progress17" ,progress17,
      // "progress18" ,progress18,
      // "progress19" ,progress19,
      // "progress20" ,progress20,
      // "progress21" ,progress21,
      // "progress22" ,progress22,
      // "progress23" ,progress23,
      // "progress24" ,progress24,
      // "progress25" ,progress25,
      // "progress26" ,progress26,
      // "progress27" ,progress27,
      // "progress28" ,progress28,
      // "progress29" ,progress29,
      // "progress35" ,progress35,
      // "progress32" ,progress32,
      // "progress33" ,progress33,
      // "progress36" ,progress36,
      // "progress37" ,progress37,
      // "progress42" ,progress42,
      // "mailingAddressRequired",(this.state.data.mailingAddressRequired === "YES"
      //   ? progress38 + progress39 + progress40
      //   : 0) ,
      //   "progress41",
      // (data.ltcInd === "Y" ? progress41 : 0))

      // console.log("count", count);

      // console.log("progress=>",progress,(progress1 +
      //   progress2 +
      //   progress3 +
      //   progress4 +
      //   progress5 +
      //   progress6 +
      //   progress7 +
      //   progress8 +
      //   progress9 +
      //   progress10 +
      //   progress11 +
      //   progress12 +
      //   progress13 +
      //   progress14 +
      //   progress15 +
      //   progress16 +
      //   progress17 +
      //   progress18 +
      //   progress19 +
      //   progress20 +
      //   progress21 +
      //   progress22 +
      //   progress23 +
      //   progress24 +
      //   progress25 +
      //   progress26 +
      //   progress27 +
      //   progress28 +
      //   progress29 +
      //   progress35 +
      //   progress32 +
      //   progress33 +
      //   progress36 +
      //   progress37 +
      //   progress42 +
      //   (this.state.data.mailingAddressRequired === "YES"
      //     ? progress38 + progress39 + progress40
      //     : 0) +
      //   (data.ltcInd === "Y" ? progress41 : 0)))
    }

    let Step2 = "";
    if (
      (this.props.year === "2022" ||
        this.props.year === "2023" ||
        this.props.year === "2024" ||
        this.props.year === "2025") &&
      productCategory === "INDIVIDUAL"
    ) {
      Step2 = Step2_2021;
    } else {
      Step2 = Step2Category1;
      if (productCategory === "GROUP") {
        Step2 = Step2Category2;
      }

      if (productCategory === "RETIREE") {
        Step2 = Step2Category3;
      }
    }

    if (productCategory === "RETIREE") {
      Step2 = Step2Category3;
    }

    const { checkName } = this.state;
    if (productCategory === "INDIVIDUAL") {
      test = this.state.disableCheck
        ? checkName === "aep" ||
          checkName === "sep" ||
          checkName === "c1" ||
          checkName === "c6" ||
          checkName === "c7" ||
          checkName === "c13" ||
          checkName === "c14" ||
          checkName === "c25" ||
          checkName === "c21" ||
          checkName === "c20"
          ? false
          : data.attestation2 !== "" ||
            data.attestation3 !== "" ||
            data.attestation4 !== "" ||
            data.attestation5 !== "" ||
            data.attestation8 !== "" ||
            data.attestation9 !== "" ||
            data.attestation10 !== "" ||
            data.attestation11 !== "" ||
            data.attestation12 !== "" ||
            data.attestation15 !== "" ||
            data.c16Attestation !== "" ||
            data.attestation16 !== "" ||
            data.recentlyChangeMedicaid != "" ||
            data.attestation23 != ""
          ? false
          : true
        : false;
    } else {
      test = this.state.disableCheck
        ? checkName === "aep" ||
          checkName === "sep" ||
          checkName === "c1" ||
          checkName === "c6" ||
          checkName === "c7" ||
          checkName === "c13" ||
          checkName == "c14" ||
          checkName === "c21" ||
          checkName === "c20" ||
          checkName === "c25"
          ? false
          : data.attestation2 !== "" ||
            data.attestation3 !== "" ||
            data.attestation4 !== "" ||
            data.attestation5 !== "" ||
            data.attestation8 !== "" ||
            data.attestation9 !== "" ||
            data.attestation10 !== "" ||
            data.attestation11 !== "" ||
            data.attestation12 !== "" ||
            data.attestation15 !== "" ||
            data.c16Attestation !== "" ||
            data.attestation16 !== ""
          ? false
          : true
        : false;
    }
    return (
      <React.Fragment>
        <div class="background">
          <Modal
            show={this.state.showpopUp || this.props.storeshowpopUp}
            backdrop="static"
            onHide={this.Okhandler}
            centered
          >
            <Modal.Body>
              {/* <h4 class="section-head">Session Timed out </h4> */}
              {this.props?.storeshowpopUp === true ? (
                <div>
                  <p>
                    <Text id="sharp.tryLater" />
                  </p>
                </div>
              ) : (
                <div>
                  <p>Application is already submitted.</p>
                  <p>Please create a new application</p>
                </div>
              )}
              <button
                onClick={this.Okhandler}
                className="btn-primary-continue mr-3 idle-yes"
              >
                OK
              </button>
            </Modal.Body>
          </Modal>
          <Snackbar
            open={snackBarOpen}
            autoHideDuration={6000}
            onClose={this.handleClose}
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
          >
            <Alert onClose={this.handleClose} severity={severity}>
              {alertMsg}
            </Alert>
          </Snackbar>
          <div className="jumbotron">
            <div className="container-xxl container-fluid">
              <div className="text-right mb-2">
                <SaveProgress state={this.state} getData={this.getData} />
              </div>
              <div className="row">
                <div>
                  <CUSTOMER_LOGO />
                </div>
              </div>
              <RetireeText />
            </div>
          </div>

          <div className="container-xxl container-fluid mt-3">
            <div className="row">
              <div className="col-12 col-xl-2  mb-2">
                <ul
                  class="nav nav-pills nav-justified"
                  value={this.state.stepVal}
                  onClick={this.handleSteps}
                >
                  {this.props.agentLogin ? (
                    <li class="nav-item">
                      <a
                        class={
                          this.state.stepVal === "step0"
                            ? "nav-link-steps active"
                            : "nav-link-steps"
                        }
                        data-toggle="tab"
                        id="step0"
                        style={{ padding: ".1rem 1rem" }}
                      >
                        <Text id="app.soa" />
                      </a>
                    </li>
                  ) : null}
                  <li class="nav-item">
                    <a
                      class={
                        this.state.stepVal === "step1"
                          ? "nav-link-steps active"
                          : "nav-link-steps"
                      }
                      data-toggle="tab"
                      id="step1"
                      style={{ padding: ".1rem 1rem" }}
                    >
                      <Text id="app.Step" /> 1
                    </a>
                  </li>
                  <li class="nav-item">
                    <a
                      class={
                        this.state.stepVal === "step2"
                          ? "nav-link-steps active"
                          : "nav-link-steps"
                      }
                      data-toggle="tab"
                      id="step2"
                      style={{ padding: ".1rem 1rem" }}
                    >
                      <Text id="app.Step" /> 2
                    </a>
                  </li>
                  <li class="nav-item">
                    <a
                      class={
                        this.state.stepVal === "step3"
                          ? "nav-link-steps active"
                          : "nav-link-steps"
                      }
                      data-toggle="tab"
                      id="step3"
                      style={{ padding: ".1rem 1rem" }}
                    >
                      <Text id="app.Step" /> 3
                    </a>
                  </li>
                  {!(
                    productCategory === "INDIVIDUAL" ||
                    productCategory === "GROUP"
                  ) ? (
                    <li class="nav-item">
                      <a
                        class={
                          this.state.stepVal === "step4"
                            ? "nav-link-steps active"
                            : "nav-link-steps"
                        }
                        data-toggle="tab"
                        id="step4"
                        style={{ padding: ".1rem 1rem" }}
                      >
                        <Text id="app.Step" /> 4
                      </a>
                    </li>
                  ) : null}
                  {this.props.agentLogin === true && (
                    <li class="nav-item preview-aligner">
                      <a
                        class={
                          this.state.stepVal === "step5"
                            ? "nav-link-steps active"
                            : "nav-link-steps"
                        }
                        data-toggle="tab"
                        id="step5"
                      >
                        Preview
                      </a>
                    </li>
                  )}
                </ul>
              </div>
              <div className="col-12 col-xl-10">
                <div className="tab-content tab-contentSharp">
                  {this.state.stepVal === "step0" && (
                    <Soa
                      data={this.state.data}
                      redirect={this.redirect}
                      authorizedrelations={this.props.authorizedrelations}
                      isSoaFilled={this.state.isSoaFilled}
                    />
                  )}
                  {this.state.stepVal === "step1" && (
                    <Step1
                      clickedSaveNextIds={this?.state?.clickedSaveNextIds}
                      selectedPlan={this.props.selectedPlan}
                      data={this.state.data}
                      handleNumberChange={this.handleNumberChange}
                      authorizedrelations={this.props.authorizedrelations}
                      handleChange={this.handleChange}
                      redirect={this.redirect}
                      handleDates={this.handleDates}
                      handleDate={this.handleDate}
                      handleCheckbox={this.handleCheckbox}
                      handleCheckbox2={this.handleCheckbox2}
                      handleStepCheckbox={this.handleStepCheckbox}
                      planCategory={productCategory}
                      checkEligibility={this.checkEligibility}
                      handleReqEffDates={this.handleReqEffDates}
                      handleDateNew={this.handleDateNew}
                      proposedvalid={this.state.proposedvalid}
                    />
                  )}
                  {this.state.stepVal === "step2" && (
                    <Step2
                      clickedSaveNextIds={this?.state?.clickedSaveNextIds}
                      selectedPlan={this.props.selectedPlan}
                      data={this.state.data}
                      handleChange={this.handleChange}
                      handleStepCheckbox={this.handleStepCheckbox}
                      handleNumberChange={this.handleNumberChange}
                      pcpChange={this.pcpChange}
                      physicians={this.state.physicians}
                      redirect={this.redirect}
                      handleDates={this.handleDates}
                      handleDate={this.handleDate}
                      handleCheckbox={this.handleCheckbox}
                      handleCheckbox2={this.handleCheckbox2}
                      setSnackBar={this.setSnackBar}
                      checkEligibility={this.checkEligibility}
                      planCategory={productCategory}
                      selectedAttestation={this.state.attestationList}
                      url={this.state.viewurl}
                      viewFile={this.viewFile}
                      uploadFiles1={this.uploadFiles}
                      fileType={this.state.fileType}
                      removeFile={this.removeFile}
                      typeOfFilesToUpload={this.state.typeOfFilesToUpload}
                      selectedFiles={this.state.selectedFiles}
                      dpzipCode={this.props.dpzipCode}
                    />
                  )}
                  {this.state.stepVal === "step3" && (
                    <Step3
                      clickedSaveNextIds={this?.state?.clickedSaveNextIds}
                      selectedPlan={this.props.selectedPlan}
                      data={this.state.data}
                      handleCheckbox={this.handleCheckbox}
                      redirect={this.redirect}
                      disableCheck={this.state.disableCheck}
                      handleChange={this.handleChange}
                      handleDates={this.handleDates}
                      handleDate={this.handleDate}
                      handleStepCheckbox={this.handleStepCheckbox}
                      attestationList={this.state.attestationList}
                      setQSNS={this.setQSNS}
                      //setDateInd={this.setDateInd}
                      handleAttestationDate={this.handleAttestationDate}
                      qsnsDate={this.qsnsDate}
                      questionDate={this.state.questionDate}
                      planCategory={productCategory}
                      checkEligibility={this.checkEligibility}
                    />
                  )}
                  {!(
                    productCategory === "INDIVIDUAL" ||
                    productCategory === "GROUP"
                  ) &&
                    this.state.stepVal === "step4" && (
                      <Step4
                        clickedSaveNextIds={this?.state?.clickedSaveNextIds}
                        selectedPlan={this.props.selectedPlan}
                        data={this.state.data}
                        handleChange={this.handleChange}
                        redirect={this.redirect}
                        authorizedrelations={this.props.authorizedrelations}
                        handleDates={this.handleDates}
                        handleDate={this.handleDate}
                        planCategory={productCategory}
                        checkEligibility={this.checkEligibility}
                      />
                    )}
                  {this.props.agentLogin && this.state.stepVal === "step5" ? (
                    <Step4Agent
                      clickedSaveNextIds={this?.state?.clickedSaveNextIds}
                      selectedAttestation={this.state.attestationList}
                      url={this.state.viewurl}
                      viewFile={this.viewFile}
                      authorizedrelations={this.props.authorizedrelations}
                      physicians={this.props.physicians}
                      productName={this.props.productName}
                      uploadFiles1={this.uploadFiles}
                      saveSign={() => {}}
                      clear={() => {}}
                      fileType={this.state.fileType}
                      planName={this.props.planName || this.state.data.planName}
                      pcpName={this.props.pcpSelected.pcpName}
                      // changeSection={() => {
                      //   this.setState((prevState) => ({
                      //     ...prevState,
                      //     stepVal: "step1",
                      //   }));
                      // }}
                      changeToSection1={() => {
                        this.setState((prevState) => ({
                          ...prevState,
                          stepVal: "step1",
                        }));
                      }}
                      changeToSection2={() => {
                        this.setState((prevState) => ({
                          ...prevState,
                          stepVal: "step3",
                        }));
                      }}
                      changeToSection3={() => {
                        this.setState((prevState) => ({
                          ...prevState,
                          stepVal: "step2",
                        }));
                      }}
                      clearFiles={() => {
                        this.setState((prevState) => ({
                          ...prevState,
                          selectedFiles: [],
                        }));
                      }}
                      data={this.state.data}
                      selectedFiles={this.state.selectedFiles}
                      handleChange={this.handleChange}
                      removeFile={this.removeFile}
                      redirect={this.redirect}
                      //authorizedrelations={this.props.authorizedrelations}
                      handleDates={this.handleDates}
                      handleDate={this.handleDate}
                      typeOfFilesToUpload={this.state.typeOfFilesToUpload}
                      Soa={this.state.SOA}
                      handleChangeCategory={this.handleChangeCategory}
                      id="next5"
                    />
                  ) : null}
                  {progress === 100 &&
                  this.props.preEnrollInfo?.appStatus != "READY" &&
                  this.props.preEnrollInfo?.appStatus != "SUBMITTED" &&
                  !this.props.captcha &&
                  this.state.stepVal === "step3" &&
                  (productCategory === "INDIVIDUAL" ||
                    productCategory === "GROUP") ? (
                    <>
                      <br />
                      <div class="float-right-md" style={{ display: "flex" }}>
                        <Captcha />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {progress === 100 &&
                  this.props.preEnrollInfo?.appStatus != "READY" &&
                  this.props.preEnrollInfo?.appStatus != "SUBMITTED" &&
                  !this.props.captcha &&
                  this.state.stepVal === "step4" &&
                  productCategory === "RETIREE" ? (
                    <>
                      <br />
                      <div class="float-right-md" style={{ display: "flex" }}>
                        <Captcha />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="row" style={{ marginTop: "0.9rem" }}>
              <div className="col-md-2" />
              {this.props.preEnrollInfo?.appStatus != "READY" &&
                this.props.preEnrollInfo?.appStatus != "SUBMITTED" && (
                  <>
                    <div className="col-md-8">
                      {progress !== 100 || !this.props.captcha ? (
                        <span
                          class="small text-danger"
                          style={{ fontSize: "15px !important" }}
                        >
                          <strong>
                            <Text id="app.error1" />
                            {!(
                              productCategory === "INDIVIDUAL" ||
                              productCategory === "GROUP"
                            )
                              ? " steps 1-4 "
                              : " steps 1-3 "}
                            <Text id="app.captchaerrorSharp" /> .
                          </strong>
                        </span>
                      ) : (
                        <span class="small text-success">
                          <strong>
                            <Text id="app.cong" />.
                          </strong>
                        </span>
                      )}
                    </div>
                    <div className="col-md-2">
                      <button
                        className={
                          progress === 100 && this.props.captcha === true
                            ? "btn btn-primary float-right"
                            : "btn btn-secondary float-right"
                        }
                        id="submit"
                        onClick={this.submitData}
                        //disabled={!(progress === 100 && !test && this.props.captcha)}
                        disabled={!(progress === 100 && this.props.captcha)}
                      >
                        <Text id="app.submit" />
                      </button>
                    </div>
                  </>
                )}
            </div>
            <br />
            {productCategory ? (
              <p style={{ float: "left", marginTop: "20px" }}>
                <strong>
                  {
                    LANG.FOOTERPLANTYPE[this.props.lang][productCategory][
                      this.props.year
                    ]
                  }
                </strong>
              </p>
            ) : (
              <div class="col-md-3"></div>
            )}
            <div style={{ marginTop: "5rem", textAlign: "left" }}>
              <Text id="app.newfooter" />
            </div>
            <StepsFooter />
          </div>

          {/* {
            <SharpFooter />
          } */}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    preEnrollInfo: state.webApp.preEnrollInfo,
    guestLogin: state.login.guestLogin,
    physicians: state.webApp.physicians,
    authorizedrelations: state.webApp.authorizedrelations,
    selectedPlan: state.login.selectedPlan,
    lang: state.webApp.language,
    captcha: state.webApp.Captcha,
    physiciansData: state.webApp.physiciansData,
    pendingApplFlag: state.webApp.pendingApplFlag,
    customerId: state.login.customerId,
    productCategory: state.login.productCategory
      ? state.login.productCategory
      : state.webApp.preEnrollInfo?.productCategory,
    guestbeneagentAppNum: state.webApp.guestbeneagentAppNum,
    appNum: state.webApp.appNum,
    count: state.webApp.count,
    county: state.webApp.county,
    planName: state.login.selectedPlanName
      ? state.login.selectedPlanName
      : state.webApp.preEnrollInfo?.planName,
    deeplink: state.login.deeplink,
    dpcountyName: state.login.dpcountyName,
    dpzipCode: state.login.dpzipCode,
    dpProductId: state.login.dpProductId,
    productId: state.login.productId,
    premiumAmount: state.login.premiumAmount,
    stateId: state.webApp.stateId,
    CountyCd: state.webApp.CountyCd,
    agentId: state.login.agentId,
    soa: state.webApp.soa,
    productIds: state.webApp.productIds,
    planType: state.webApp.planType,
    pcpSelected: state.webApp.selectedVo,
    qsns: state.webApp.qsns,
    agentLogin: state.login.agentLoggedIn,
    productName: state.login.selectedProductName,
    ZipCodes: state.webApp.zipCodes,
    uploadedFilesInPreEnroll: state.webApp.uploadedFilesInPreEnroll,
    zip: state.webApp.zip,
    cardDetails: state.webApp.planCardData,
    cityName: state.webApp.cityName,
    storeshowpopUp: state.webApp.storeshowpopUp,
    userId: state.login.userId,
  };
};
const mapDispatchToProps = {
  resetStore,
  saveLogout,
  submitForm,
  getClinicalName,
  removeplan,
  captchaValidation,
  setPageName,
  setStateParams,
  checkEligibility,
  uploadFile,
  deleteFile,
  yearSelection,
  setLoginStateParams,
  guestLogin,
  getZipCodes,
  getPlansEmail,
  setTokenTORedux,
  setDeepLink,
  getPlans,
  setEnrollRedirect,
  planSelectionContinue,
  setPendingApplFlag,
  downloadFormsPdf,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PreEnrollForm));
